// mainWorkflow.js - Complete file with all functionality included
// No external imports - everything is in this single file

// ==================== HELPER FUNCTIONS ====================

function patchOrAppendChatSections(prevChats, newObj, keysToAdd) {
  console.log('[WORKFLOW] patchOrAppendChatSections called:', {
    prevChatsLength: prevChats.length,
    newObjKeys: Object.keys(newObj),
    keysToAddKeys: Object.keys(keysToAdd),
    iterations: keysToAdd.iterations
  });

  if (prevChats.length === 0) {
    localStorage.setItem('isEnabled', 'false');
    return [newObj];
  }
  let isEnabled = localStorage.getItem('isEnabled');
  if (isEnabled === 'true') {
    console.log('[WORKFLOW] Adding new chat section');
    const updated = [...prevChats];
    updated.push(newObj);
    localStorage.setItem('isEnabled', 'false');
    return updated;
  }
  const updated = [...prevChats];
  const lastIndex = updated.length - 1;
  const lastElem = updated[lastIndex];
  updated[lastIndex] = { ...lastElem, ...keysToAdd };

  console.log('[WORKFLOW] Updated last chat section:', {
    lastIndex,
    updatedIterations: updated[lastIndex].iterations
  });

  return updated;
}

// ==================== MISSING HELPER FUNCTIONS (FIXES) ====================

const estimateTokens = (text) => {
  // Rough estimate: 1 token ≈ 4 characters for English
  return Math.ceil(text.length / 4);
};

const detectChunkType = (content) => {
  if (content.includes('CANDIDATE')) return 'candidate_profiles';
  if (content.includes('EXPERIENCE')) return 'experiences';
  if (content.includes('SUMMARY')) return 'summary';
  if (content.includes('RECOMMENDATION')) return 'recommendations';
  return 'general';
};

const summarizePrevious = (chunkResults) => {
  // Create a concise summary to maintain context
  return chunkResults.map((result, idx) => 
    `Chunk ${idx + 1}: ${typeof result === 'string' ? 
      result.substring(0, 200) : 
      (result.summary || result.substring(0, 200))}...`
  ).join('\n');
};

const synthesizeChunkResults = (chunkResults) => {
  // Combine all chunk analyses intelligently
  return {
    fullAnalysis: chunkResults.map(r => 
      typeof r === 'string' ? r : (r.content || r.analysis || r)
    ).join('\n\n'),
    wasChunked: true,
    chunkCount: chunkResults.length,
    chunkDetails: chunkResults.map(r => ({
      type: typeof r === 'object' ? r.type : 'text',
      length: typeof r === 'string' ? r.length : (r.length || 0),
      keyFindings: typeof r === 'object' ? r.keyFindings : undefined
    }))
  };
};

const extractKeyFindings = (result) => {
  // Extract key findings from a result string
  if (!result) return '';
  const lines = result.split('\n');
  const keyLines = lines.filter(line => 
    line.includes('Key') || 
    line.includes('Finding') || 
    line.includes('Recommendation') ||
    line.includes('•') ||
    line.startsWith('-')
  );
  return keyLines.slice(0, 5).join('\n').substring(0, 500);
};

const updateProgress = (progress) => {
  // Update UI progress indicator
  console.log('[WORKFLOW] Progress Update:', progress);
  // You can dispatch this to your UI state management here if needed
};

// ==================== API HELPERS ====================

const getAuthHeaders = async () => {
  // Replace this with your actual auth implementation
  const authToken = localStorage.getItem('authToken') || '';
  return {
    'Authorization': authToken ? `Bearer ${authToken}` : '',
    'Content-Type': 'application/json'
  };
};

// Helper function to parse SSE format responses
const parseSSEResponse = (responseText, provider) => {
  console.log('[WORKFLOW] 📡 Parsing SSE response for', provider);
  console.log('[WORKFLOW] 📝 Response length:', responseText.length);

  const lines = responseText.split('\n');
  console.log(`[WORKFLOW] 📝 Total lines: ${lines.length}`);

  let accumulatedContent = '';
  let processedChunks = 0;
  let debugInfo = [];

  for (const line of lines) {
    if (!line || !line.startsWith('data: ')) continue;

    const jsonStr = line.substring(6).trim();

    if (jsonStr === '[DONE]') {
      console.log('[WORKFLOW] ✅ SSE stream complete marker found');
      continue;
    }

    try {
      const parsed = JSON.parse(jsonStr);
      processedChunks++;

      if (processedChunks === 1) {
        console.log('[WORKFLOW] 🔍 First chunk structure:', JSON.stringify(parsed, null, 2).substring(0, 500));
      }

      let chunkContent = '';

      if (provider === 'deepseek') {
        chunkContent = parsed.choices?.[0]?.delta?.content ||
          parsed.choices?.[0]?.message?.content ||
          parsed.choices?.[0]?.text ||
          parsed.delta?.content ||
          parsed.content ||
          parsed.text || '';

        if (!chunkContent && parsed.choices?.[0]?.message?.content) {
          console.log('[WORKFLOW] 🔍 Found complete message in SSE format at chunk:', processedChunks);
          chunkContent = parsed.choices[0].message.content;
        }

        if (!chunkContent && parsed.choices?.[0] && typeof parsed.choices[0] === 'string') {
          console.log('[WORKFLOW] 🔍 Found string content directly in choices[0]');
          chunkContent = parsed.choices[0];
        }

        if (processedChunks <= 3) {
          debugInfo.push({
            chunk: processedChunks,
            hasChoices: !!parsed.choices,
            hasDelta: !!parsed.choices?.[0]?.delta,
            hasMessage: !!parsed.choices?.[0]?.message,
            hasContent: !!chunkContent,
            contentLength: chunkContent.length
          });
        }
      } else if (provider === 'claude' || provider === 'anthropic') {
        chunkContent = parsed.delta?.text ||
          parsed.content?.[0]?.text ||
          parsed.content ||
          parsed.text || '';
      }

      if (!chunkContent && processedChunks <= 5) {
        const possibleFields = ['content', 'text', 'message', 'response', 'output', 'result'];
        for (const field of possibleFields) {
          if (parsed[field] && typeof parsed[field] === 'string') {
            console.log(`[WORKFLOW] 🔧 Found content in field '${field}'`);
            chunkContent = parsed[field];
            break;
          }
        }

        if (!chunkContent && typeof parsed === 'string') {
          console.log('[WORKFLOW] 🔧 Parsed object is a string itself');
          chunkContent = parsed;
        }
      }

      accumulatedContent += chunkContent;

    } catch (parseError) {
      console.warn('[WORKFLOW] Failed to parse SSE chunk:', jsonStr.substring(0, 100));
      console.warn('[WORKFLOW] Parse error:', parseError.message);
    }
  }

  console.log('[WORKFLOW] 🔍 Debug info for first chunks:', debugInfo);
  console.log(`[WORKFLOW] ✅ Processed ${processedChunks} SSE chunks`);
  console.log(`[WORKFLOW] 📊 Total accumulated content: ${accumulatedContent.length} chars`);

  if (accumulatedContent.length === 0 && processedChunks > 0) {
    console.error('[WORKFLOW] ⚠️ WARNING: Processed chunks but no content extracted!');
    console.log('[WORKFLOW] 📝 Sample of raw response:', responseText.substring(0, 1000));

    const contentMatch = responseText.match(/"content"\s*:\s*"([^"\\]*(\\.[^"\\]*)*)"/);
    if (contentMatch) {
      console.log('[WORKFLOW] 🔧 Using regex fallback to extract content');
      accumulatedContent = contentMatch[1].replace(/\\n/g, '\n').replace(/\\"/g, '"');
    }
  }

  return {
    content: accumulatedContent,
    streaming: true,
    chunks: processedChunks,
    debugInfo
  };
};

// Helper function to parse regular JSON responses
const parseJSONResponse = (responseText, provider) => {
  console.log('[WORKFLOW] 📦 Parsing regular JSON response for', provider);
  console.log('[WORKFLOW] 📝 Response length:', responseText.length);

  const parsed = JSON.parse(responseText);
  console.log('[WORKFLOW] 🔍 Parsed structure keys:', Object.keys(parsed));

  let content = '';

  if (provider === 'deepseek') {
    content = parsed.choices?.[0]?.message?.content ||
      parsed.choices?.[0]?.text ||
      parsed.message?.content ||
      parsed.content ||
      parsed.text || '';

    if (!content && parsed.choices?.[0]) {
      console.log('[WORKFLOW] 🔍 DeepSeek choice[0] keys:', Object.keys(parsed.choices[0]));
      if (parsed.choices[0].message) {
        console.log('[WORKFLOW] 🔍 Message keys:', Object.keys(parsed.choices[0].message));
      }
    }
  } else if (provider === 'claude' || provider === 'anthropic') {
    content = parsed.content?.[0]?.text ||
      parsed.content ||
      parsed.text || '';
  }

  console.log(`[WORKFLOW] 📊 Extracted content length: ${content.length} chars`);

  return {
    content: content,
    streaming: false,
    raw: parsed
  };
};

// Non-streaming API call
const callLLMProxy = async (provider, data, signal = null) => {
  let controller;
  let timeoutId;
  let cleanupAbortListener;

  try {
    const headers = await getAuthHeaders();

    if (data.temperature !== undefined) {
      data.temperature = parseFloat(data.temperature) || 0.7;
      data.temperature = Math.min(2.0, Math.max(0.0, data.temperature));
    }

    let endpoint;
    const normalizedProvider = provider.toLowerCase();
    switch (normalizedProvider) {
      case 'deepseek':
        endpoint = '/api/llm/deepseek';
        break;
      case 'anthropic':
      case 'claude':
        endpoint = '/api/llm/claude';
        break;
      default:
        throw new Error(`Unknown provider: ${provider}`);
    }

    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    console.log(`[WORKFLOW] 🚀 Calling ${provider} at ${endpoint}`);

    controller = new AbortController();

    if (signal) {
      if (signal.aborted) {
        console.log(`[WORKFLOW] 🛑 ${provider} request already aborted`);
        throw new Error(`${provider} request was cancelled`);
      }

      const abortHandler = () => {
        console.log(`[WORKFLOW] 🛑 Aborting ${provider} request due to external signal`);
        if (controller && !controller.signal.aborted) {
          controller.abort();
        }
      };

      cleanupAbortListener = () => {
        if (signal) {
          signal.removeEventListener('abort', abortHandler);
        }
      };

      signal.addEventListener('abort', abortHandler);
    }

    timeoutId = setTimeout(() => {
      console.log('[WORKFLOW] ⏱️ Request timeout - aborting...');
      if (controller && !controller.signal.aborted) {
        controller.abort();
      }
    }, 180000);

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
      signal: controller.signal
    });

    clearTimeout(timeoutId);
    timeoutId = null;

    if (!response.ok) {
      let errorMessage;
      try {
        const error = await response.json();
        errorMessage = error.error || error.message;
      } catch {
        errorMessage = `HTTP ${response.status} error`;
      }

      console.error(`[WORKFLOW] ❌ LLM API error:`, errorMessage);

      if (response.status === 504) {
        throw new Error('Request timeout - the AI is taking too long. Try with a shorter prompt.');
      } else if (response.status === 429) {
        throw new Error('Rate limit exceeded. Please wait a moment and try again.');
      } else if (response.status === 503) {
        throw new Error(`${provider} service is not available. Please try another provider.`);
      } else {
        throw new Error(errorMessage || 'LLM API call failed');
      }
    }

    let responseText;
    try {
      responseText = await response.text();
    } catch (readError) {
      if (readError.name === 'AbortError') {
        console.log(`[WORKFLOW] 🛑 Response reading aborted for ${provider}`);
        throw new Error(`${provider} request was cancelled`);
      }
      throw readError;
    }

    console.log('[WORKFLOW] 📝 Response preview:', responseText.substring(0, 200));

    let result;

    if (responseText.startsWith('data: ')) {
      console.log('[WORKFLOW] 🔄 Detected SSE (streaming) response format');
      result = parseSSEResponse(responseText, normalizedProvider);
    } else {
      console.log('[WORKFLOW] 📦 Detected regular JSON response format');
      try {
        result = parseJSONResponse(responseText, normalizedProvider);
      } catch (parseError) {
        console.error('[WORKFLOW] ❌ Failed to parse response:', parseError);
        console.error('[WORKFLOW] Response text:', responseText.substring(0, 500));
        throw new Error(`Invalid response format from ${provider}: ${parseError.message}`);
      }
    }

    if (!result.content && result.chunks > 0) {
      console.error('[WORKFLOW] ⚠️ Processed SSE chunks but no content extracted');
    }

    if (!result.content) {
      console.warn('[WORKFLOW] ⚠️ Empty content in response');
      console.warn('[WORKFLOW] 🔍 Full result object:', JSON.stringify(result, null, 2));

      if (responseText.includes('error') || responseText.includes('Error')) {
        const errorInfo = responseText.match(/"error"\s*:\s*"([^"]+)"/);
        if (errorInfo) {
          throw new Error(`API returned error: ${errorInfo[1]}`);
        }
      }

      throw new Error(`No content in response from ${provider} - received ${responseText.length} chars, ${result.chunks || 0} chunks processed`);
    }

    console.log(`[WORKFLOW] ✅ ${provider} response received - ${result.content.length} chars, streaming: ${result.streaming}`);
    return result;

  } catch (error) {
    if (error.name === 'AbortError' ||
      (error.message && error.message.includes('was cancelled')) ||
      (error.message && error.message.includes('aborted'))) {
      console.log(`[WORKFLOW] ⏱️ ${provider} request aborted`);
      throw new Error(`${provider} request was cancelled`);
    }
    console.error(`[WORKFLOW] ❌ Error calling ${provider}:`, error);
    throw error;
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (cleanupAbortListener) {
      cleanupAbortListener();
    }
  }
};

// Wrapper for calling the actor model (ADDED FIX)
const callActorModel = async (prompt, signal, Actor_Model_apiProvider, Actor_Model_apiModel, temperature_val_Actor_Model_apiProvider) => {
  // Wrapper for calling the actor model using existing LLM proxy logic
  const provider = Actor_Model_apiProvider === 'Anthropic' ? 'claude' : 'deepseek';
  
  const response = await callLLMProxy(provider, {
    prompt,
    model: Actor_Model_apiModel || (provider === 'claude' ? 'claude-3-opus-20240229' : 'deepseek-reasoner'),
    temperature: parseFloat(temperature_val_Actor_Model_apiProvider) || 0.3,
    max_tokens: 8192
  }, signal);
  
  return response.content;
};

// Streaming API call
const callLLMProxyStreaming = async (provider, data, signal = null, onChunk = null) => {
  let controller;
  let timeoutId;
  let cleanupAbortListener;
  let reader;

  try {
    const headers = await getAuthHeaders();

    if (data.temperature !== undefined) {
      data.temperature = parseFloat(data.temperature) || 0.7;
      data.temperature = Math.min(2.0, Math.max(0.0, data.temperature));
    }

    data.stream = true;

    let endpoint;
    const normalizedProvider = provider.toLowerCase();
    switch (normalizedProvider) {
      case 'deepseek':
        endpoint = '/api/llm/deepseek';
        break;
      case 'anthropic':
      case 'claude':
        endpoint = '/api/llm/claude';
        break;
      default:
        throw new Error(`Unknown provider: ${provider}`);
    }

    console.log(`[WORKFLOW] 🚀 Calling ${provider} at ${endpoint} with streaming`);
    console.log('[WORKFLOW] 📦 Request data:', {
      model: data.model,
      temperature: data.temperature,
      stream: data.stream,
      promptLength: data.prompt?.length || data.messages?.[0]?.content?.length || 0
    });

    controller = new AbortController();

    if (signal) {
      if (signal.aborted) {
        throw new Error(`${provider} request was cancelled`);
      }

      const abortHandler = () => {
        console.log(`[WORKFLOW] 🛑 Aborting ${provider} streaming request due to external signal`);
        if (controller && !controller.signal.aborted) {
          controller.abort();
        }
        if (reader) {
          reader.cancel().catch(() => { });
        }
      };

      cleanupAbortListener = () => {
        if (signal) {
          signal.removeEventListener('abort', abortHandler);
        }
      };

      signal.addEventListener('abort', abortHandler);
    }

    timeoutId = setTimeout(() => {
      console.log('[WORKFLOW] ⏱️ Streaming request timeout - aborting...');
      if (controller && !controller.signal.aborted) {
        controller.abort();
      }
    }, 180000);

    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
      signal: controller.signal
    });

    clearTimeout(timeoutId);
    timeoutId = null;

    const contentType = response.headers.get('content-type');
    console.log(`[WORKFLOW] 📋 Response content-type: ${contentType}`);
    console.log(`[WORKFLOW] 📋 Response status: ${response.status}`);

    if (!response.ok) {
      let errorMessage;
      try {
        const errorText = await response.text();
        console.error(`[WORKFLOW] ❌ Error response text:`, errorText);

        try {
          const error = JSON.parse(errorText);
          errorMessage = error.error || error.message || errorText;
        } catch {
          errorMessage = errorText || `HTTP ${response.status} error`;
        }
      } catch {
        errorMessage = `HTTP ${response.status} error`;
      }

      console.error(`[WORKFLOW] ❌ LLM Streaming API error:`, errorMessage);

      if (response.status === 504) {
        throw new Error('Request timeout - the AI is taking too long. Try with a shorter prompt.');
      } else if (response.status === 429) {
        throw new Error('Rate limit exceeded. Please wait a moment and try again.');
      } else if (response.status === 503) {
        throw new Error(`${provider} service is not available. Please try another provider.`);
      } else {
        throw new Error(errorMessage || 'LLM API call failed');
      }
    }

    const isStreaming = contentType && (
      contentType.includes('text/event-stream') ||
      contentType.includes('application/x-ndjson') ||
      contentType.includes('text/plain')
    );

    if (!isStreaming) {
      console.warn(`[WORKFLOW] ⚠️ Response is not streaming format (content-type: ${contentType}). Parsing as regular JSON.`);

      let responseText;
      try {
        responseText = await response.text();
      } catch (readError) {
        if (readError.name === 'AbortError') {
          throw new Error(`${provider} request was cancelled`);
        }
        throw readError;
      }

      try {
        const parsed = JSON.parse(responseText);

        let content = '';
        if (normalizedProvider === 'deepseek') {
          content = parsed.choices?.[0]?.message?.content ||
            parsed.choices?.[0]?.text ||
            parsed.content || '';
        } else if (normalizedProvider === 'gemini') {
          content = parsed.candidates?.[0]?.content?.parts?.[0]?.text ||
            parsed.text ||
            parsed.content || '';
        } else if (normalizedProvider === 'claude') {
          content = parsed.content?.[0]?.text ||
            parsed.content ||
            parsed.text || '';
        }

        if (content) {
          console.log(`[WORKFLOW] ✅ Got non-streaming response with ${content.length} chars`);

          if (onChunk) {
            onChunk(content, content);
          }

          return content;
        } else {
          console.error('[WORKFLOW] ❌ No content found in non-streaming response:', parsed);
          throw new Error('No content in response');
        }
      } catch (e) {
        console.error('[WORKFLOW] ❌ Failed to parse non-streaming response:', e);
        throw new Error('Invalid response format');
      }
    }

    reader = response.body?.getReader();
    const decoder = new TextDecoder('utf-8', { stream: true });
    let accumulatedContent = '';
    let chunkCount = 0;
    let buffer = '';

    if (reader) {
      console.log('[WORKFLOW DEBUG] Starting to read stream');

      try {
        while (true) {
          if (signal?.aborted) {
            reader.cancel().catch(() => { });
            throw new Error('Streaming aborted by user');
          }

          const { done, value } = await reader.read();
          if (done) {
            console.log('[WORKFLOW DEBUG] Stream reading complete');
            break;
          }

          chunkCount++;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;

          const lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (const line of lines) {
            if (!line || !line.trim()) continue;

            if (line.startsWith('data: ')) {
              const jsonStr = line.substring(6).trim();
              if (jsonStr === '[DONE]') continue;

              try {
                const parsed = JSON.parse(jsonStr);
                let chunkContent = '';

                if (normalizedProvider === 'deepseek') {
                  chunkContent = parsed.choices?.[0]?.delta?.content ||
                    parsed.choices?.[0]?.message?.content || '';
                } else if (normalizedProvider === 'gemini' || normalizedProvider === 'google gemini') {
                  chunkContent = parsed.candidates?.[0]?.content?.parts?.[0]?.text || '';
                } else if (normalizedProvider === 'claude' || normalizedProvider === 'anthropic') {
                  chunkContent = parsed.delta?.text ||
                    parsed.content?.[0]?.text || '';
                }

                if (chunkContent) {
                  accumulatedContent += chunkContent;
                  if (onChunk) {
                    onChunk(chunkContent, accumulatedContent);
                  }
                }
              } catch (e) {
                console.warn('[WORKFLOW] Failed to parse streaming chunk:', e.message);
                console.warn('[WORKFLOW] Problematic line:', line);
              }
            } else {
              accumulatedContent += line;
              if (onChunk) {
                onChunk(line, accumulatedContent);
              }
            }
          }

          if (chunkCount % 10 === 0) {
            await new Promise(resolve => setTimeout(resolve, 10));
          }
        }

        if (buffer && buffer.trim()) {
          console.log('[WORKFLOW] Processing remaining buffer:', buffer);
          if (buffer.startsWith('data: ')) {
            const jsonStr = buffer.substring(6).trim();
            if (jsonStr !== '[DONE]') {
              try {
                const parsed = JSON.parse(jsonStr);
              } catch (e) {
                console.warn('[WORKFLOW] Failed to parse final buffer:', e.message);
              }
            }
          }
        }

        const finalChunk = decoder.decode();
        if (finalChunk) {
          accumulatedContent += finalChunk;
          if (onChunk) {
            onChunk(finalChunk, accumulatedContent);
          }
        }
      } catch (readError) {
        if (readError.name === 'AbortError' || readError.message.includes('aborted')) {
          console.log('[WORKFLOW] Stream reading was aborted');
          throw new Error(`${provider} request was cancelled`);
        }
        throw readError;
      }
    }

    console.log(`[WORKFLOW] ✅ ${provider} streaming complete - ${accumulatedContent.length} chars, ${chunkCount} chunks`);

    return accumulatedContent;

  } catch (error) {
    if (error.name === 'AbortError' ||
      (error.message && error.message.includes('was cancelled')) ||
      (error.message && error.message.includes('aborted'))) {
      console.log(`[WORKFLOW] ⏱️ ${provider} streaming request aborted`);
      throw new Error(`${provider} request was cancelled`);
    }
    console.error(`[WORKFLOW] ❌ Error in streaming call to ${provider}:`, error);
    throw error;
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (cleanupAbortListener) {
      cleanupAbortListener();
    }
    if (reader) {
      reader.cancel().catch(() => { });
    }
  }
};

// ==================== CHUNKING UTILITIES ====================

const determineOptimalChunkSize = (textLength, modelType = 'default') => {
  const modelLimits = {
    'claude': 8000,
    'deepseek': 5000,
    'gemini': 10000,
    'anthropic': 8000,
    'default': 5000
  };

  const baseLimit = modelLimits[modelType.toLowerCase()] || modelLimits.default;

  if (textLength < 8000) {
    return Math.min(textLength, baseLimit);
  } else if (textLength < 30000) {
    return Math.min(5000, baseLimit);
  } else if (textLength < 100000) {
    return Math.min(3500, baseLimit);
  } else {
    return Math.min(2500, baseLimit);
  }
};

const calculateChunkCount = (textLength, chunkSize, overlapPercentage) => {
  const overlapSize = Math.floor(chunkSize * overlapPercentage);
  const effectiveChunkSize = chunkSize - overlapSize;
  return Math.ceil((textLength - chunkSize) / effectiveChunkSize) + 1;
};

const createOverlappingChunks = (text, options = {}) => {
  const {
    overlapPercentage = 0.3,
    preserveBoundaries = true,
    modelType = 'default',
    minChunkSize = 500,
    maxChunks = 50
  } = options;

  let maxChunkSize = options.maxChunkSize || determineOptimalChunkSize(text.length, modelType);

  maxChunkSize = Math.max(minChunkSize, maxChunkSize);

  console.log('[WORKFLOW] 📦 Creating dynamic overlapping chunks');
  console.log(`[WORKFLOW]    Total text length: ${text.length} characters`);
  console.log(`[WORKFLOW]    Optimal chunk size: ${maxChunkSize} characters`);
  console.log(`[WORKFLOW]    Overlap: ${(overlapPercentage * 100).toFixed(0)}%`);

  const estimatedChunks = calculateChunkCount(text.length, maxChunkSize, overlapPercentage);
  console.log(`[WORKFLOW]    Estimated chunks: ${estimatedChunks}`);

  if (estimatedChunks > maxChunks) {
    const newChunkSize = Math.ceil(text.length / (maxChunks * (1 - overlapPercentage)));
    console.log(`[WORKFLOW]    ⚠️ Too many chunks (${estimatedChunks}), adjusting chunk size to ${newChunkSize}`);
    maxChunkSize = newChunkSize;
  }

  const chunks = [];
  const overlapSize = Math.floor(maxChunkSize * overlapPercentage);

  // Custom boundary markers for experience-based documents
  const customBoundaryMarkers = [
    '### Experience #5:',  
    'All experiences analyzed. Summary follows',
  ];

  let position = 0;
  let chunkIndex = 0;
  let previousChunkEnd = 0;
  let cappingChunks = 5000;

  while (position < text.length && chunkIndex < Math.min(maxChunks, cappingChunks)) {
    let chunkStart = position;
    let chunkEnd = Math.min(position + maxChunkSize, text.length);

    if (chunkIndex > 0 && overlapPercentage > 0) {
      const overlapStart = Math.max(0, previousChunkEnd - overlapSize);
      chunkStart = overlapStart;
    }

    chunkEnd = Math.min(chunkStart + maxChunkSize, text.length);

    if (preserveBoundaries && chunkEnd < text.length) {
      let bestBoundary = chunkEnd;
      let boundaryFound = false;

      // Look for Experience #5 specifically
      const exp5Index = text.indexOf('### Experience #5:', chunkStart);  
      if (exp5Index !== -1 && exp5Index < chunkEnd && exp5Index > chunkStart) {
        if (exp5Index - chunkStart > 1000) {  
          bestBoundary = exp5Index;
          boundaryFound = true;
          console.log(`[WORKFLOW]    Chunk ${chunkIndex + 1}: Found Experience #5 boundary at position ${exp5Index}`);
        }
      }

      if (!boundaryFound) {
        const searchStart = Math.max(chunkStart, chunkEnd - Math.floor(maxChunkSize * 0.2));
        const searchText = text.substring(searchStart, chunkEnd);

        for (const marker of customBoundaryMarkers) {
          const lastMarkerIndex = searchText.lastIndexOf(marker);

          if (lastMarkerIndex !== -1) {
            if (marker.startsWith('Experience #5') || marker.startsWith('All experiences analyzed. Summary follows')) {
              bestBoundary = searchStart + lastMarkerIndex;
            } else {
              bestBoundary = searchStart + lastMarkerIndex + marker.length;
            }
            boundaryFound = true;
            console.log(`[WORKFLOW]    Chunk ${chunkIndex + 1}: Found boundary at "${marker.substring(0, 30)}..."`);
            break;
          }
        }

        if (!boundaryFound) {
          let wordBoundary = chunkEnd;
          while (wordBoundary > chunkStart + minChunkSize &&
            text[wordBoundary] &&
            text[wordBoundary] !== ' ' &&
            text[wordBoundary] !== '\n') {
            wordBoundary--;
          }
          if (wordBoundary > chunkStart + minChunkSize) {
            chunkEnd = wordBoundary;
            console.log(`[WORKFLOW]    Chunk ${chunkIndex + 1}: No experience boundary found, cut at word boundary`);
          } else {
            console.log(`[WORKFLOW]    Chunk ${chunkIndex + 1}: No suitable boundary found, cutting at position`);
          }
        } else {
          chunkEnd = bestBoundary;
        }
      } else {
        chunkEnd = bestBoundary;
      }
    }

    const chunkContent = text.substring(chunkStart, chunkEnd);

    const actualOverlapSize = chunkIndex > 0 ? (previousChunkEnd - chunkStart) : 0;

    chunks.push({
      index: chunkIndex,
      content: chunkContent,
      start: chunkStart,
      end: chunkEnd,
      length: chunkContent.length,
      hasOverlapBefore: chunkIndex > 0,
      hasOverlapAfter: chunkEnd < text.length,
      overlapSize: actualOverlapSize,
      overlapPercentage: chunkContent.length > 0 ?
        (actualOverlapSize / chunkContent.length * 100).toFixed(1) : 0
    });

    console.log(`[WORKFLOW]    Chunk ${chunkIndex + 1}: ${chunkContent.length} chars` +
      ` (overlap: ${actualOverlapSize} chars / ${(actualOverlapSize / chunkContent.length * 100).toFixed(1)}%)`);

    previousChunkEnd = chunkEnd;
    if (overlapSize > 0) {
      position = chunkEnd - overlapSize;
    } else {
      position = chunkEnd;
    }
    chunkIndex++;

    if (position >= text.length || chunkIndex >= maxChunks) {
      break;
    }
    if (chunkEnd === chunkStart) {
      console.warn('[WORKFLOW] Zero-length chunk detected, breaking to prevent infinite loop');
      break;
    }
  }

  console.log(`[WORKFLOW]    ✅ Created ${chunks.length} chunks with ~${(overlapPercentage * 100).toFixed(0)}% overlap`);
  console.log(`[WORKFLOW]    📊 Chunk size distribution: ${chunks.map(c => c.length).join(', ')}`);

  // VERIFICATION LOGGING (ADDED FIX)
  console.log('📊 Chunk Distribution:', chunks.map(c => ({
    type: detectChunkType(c.content),
    tokens: estimateTokens(c.content),
    preview: c.content.substring(0, 50) + '...'
  })));

  return chunks;
};

// SMART CHUNKING BY CANDIDATE (ADDED FIX)
const chunkByCandidate = (report, maxCandidatesPerChunk = 2) => {
  // Extract individual candidate sections
  const candidateSections = report.split(/\*\*CANDIDATE \d+:/);
  const chunks = [];
  
  // Keep header/summary
  const header = candidateSections[0];
  
  // Group candidates
  for (let i = 1; i < candidateSections.length; i += maxCandidatesPerChunk) {
    const candidatesInChunk = candidateSections
      .slice(i, i + maxCandidatesPerChunk)
      .map((c, idx) => `**CANDIDATE ${i + idx}:${c}`)
      .join('\n\n');
    
    chunks.push({
      content: i === 1 ? header + candidatesInChunk : candidatesInChunk,
      candidateIndices: Array.from(
        {length: Math.min(maxCandidatesPerChunk, candidateSections.length - i)}, 
        (_, k) => i + k
      ),
      type: 'candidate_chunk'
    });
  }
  
  return chunks;
};

const mergeChunkedAnalyses = (chunkedResults) => {
  console.log('[WORKFLOW] 🔀 Merging chunked analysis results');
  console.log(`[WORKFLOW]    Total chunks to merge: ${chunkedResults.length}`);

  if (chunkedResults.length === 0) {
    return '';
  }

  if (chunkedResults.length === 1) {
    return chunkedResults[0].analysis || chunkedResults[0];
  }

  const mergedSections = [];
  const overlapAnalyses = new Map();

  chunkedResults.forEach((result, index) => {
    console.log(`[WORKFLOW]    Processing chunk ${index + 1}/${chunkedResults.length}`);

    const analysisContent = typeof result === 'string' ? result : result.analysis;

    if (index > 0 && (result.hasOverlapBefore || index > 0)) {
      const overlapKey = `overlap_${index - 1}_${index}`;
      const prevContent = typeof chunkedResults[index - 1] === 'string' ?
        chunkedResults[index - 1] : chunkedResults[index - 1].analysis;

      overlapAnalyses.set(overlapKey, {
        fromPrevious: prevContent,
        fromCurrent: analysisContent,
        overlapSize: result.overlapSize || 0,
        chunkIndex: index
      });

      const analysisLines = analysisContent.split('\n');
      const uniqueStartIndex = Math.floor(analysisLines.length * 0.3);
      const uniqueContent = analysisLines.slice(uniqueStartIndex).join('\n');

      mergedSections.push({
        chunk: index,
        analysis: uniqueContent,
        isPartial: true,
        confidence: result.confidence || 1.0
      });
    } else {
      mergedSections.push({
        chunk: index,
        analysis: analysisContent,
        isPartial: false,
        confidence: result.confidence || 1.0
      });
    }
  });

  console.log(`[WORKFLOW]    Reconciling ${overlapAnalyses.size} overlapping sections`);

  const finalContent = mergedSections
    .map((section, idx) => {
      if (idx > 0 && idx < mergedSections.length) {
        return `\n---\n${section.analysis}`;
      }
      return section.analysis;
    })
    .join('\n');

  console.log(`[WORKFLOW]    ✅ Merge complete - final length: ${finalContent.length} characters`);

  return finalContent;
};

const CHUNK_CONFIGS = {
  standard: {
    maxChunkSize: 125000,  
    overlapPercentage: 0.0,  // SET TO ZERO for no overlap
    preserveBoundaries: true,
    minChunkSize: 125000,
    maxChunks: 2  // Force exactly 2 chunks maximum
  },
}

const selectChunkConfig = (textLength, complexity = 'standard', modelType = 'default') => {
  let config;

  if (textLength > 500000) {
    config = { ...CHUNK_CONFIGS.massive };
  } else if (textLength > 200000) {
    config = { ...CHUNK_CONFIGS.large };
  } else if (textLength > 100000 || complexity === 'complex') {
    config = { ...CHUNK_CONFIGS.complex };
  } else {
    config = { ...CHUNK_CONFIGS.standard };
  }

  config.modelType = modelType;

  console.log(`[WORKFLOW]    📋 Selected config: ${textLength > 500000 ? 'massive' : textLength > 200000 ? 'large' : textLength > 100000 ? 'complex' : 'standard'}`);
  console.log(`[WORKFLOW]    📏 Text length: ${textLength}, Model: ${modelType}`);

  return config;
};

const getChunkHeaders = (chunkIndex, totalChunks) => {
  const position = chunkIndex + 1;
  const isFirst = chunkIndex === 0;
  const isLast = chunkIndex === totalChunks - 1;
  const isSecondLast = chunkIndex === totalChunks - 2;

  const headerMap = {
    first: [
      "Executive Overview",
      "Key Candidates & Initial Assessment",
      "Primary Themes & Context",
      "Analytical Framework"
    ],
    earlyMiddle: [
      "Regulatory & Transactional Deep Dive",
      "Sector-Specific Analysis",
      "Experience Mapping",
      "Competency Assessment"
    ],
    middle: [
      "Detailed Pattern Analysis",
      "Cross-Functional Insights",
      "Geographic & Market Considerations",
      "Technical Qualifications Review"
    ],
    lateMiddle: [
      "Emerging Recommendations",
      "Strategic Alignment",
      "Risk & Opportunity Assessment",
      "Comparative Analysis"
    ],
    secondLast: [
      "Synthesis & Integration",
      "Preliminary Recommendations",
      "Implementation Considerations",
      "Strategic Priorities"
    ],
    last: [
      "Final Assessment",
      "Actionable Recommendations",
      "Next Steps & Implementation",
      "Executive Summary",
      "Final Note"
    ]
  };

  if (isFirst) return headerMap.first;
  if (isLast) return headerMap.last;
  if (isSecondLast) return headerMap.secondLast;

  const middleProgress = (position - 1) / (totalChunks - 2);
  if (middleProgress < 0.33) return headerMap.earlyMiddle;
  if (middleProgress < 0.66) return headerMap.middle;
  return headerMap.lateMiddle;
};

// PROCESS ACTOR ANALYSIS WITH RETRY (ADDED FIX)
const processActorAnalysisWithRetry = async (initialReport, signal, actor_model_streaming, setAPIError) => {
  try {
    const chunks = chunkInitialReport(initialReport);
    
    if (chunks.length === 0) {
      throw new Error('Failed to chunk report - no content found');
    }
    
    if (chunks.some(c => c.tokens > 8000)) {
      console.warn('⚠️ Some chunks exceed optimal size, may need further splitting');
    }
    
    return await processActorAnalysis(initialReport, signal);
  } catch (error) {
    console.error('❌ Actor analysis chunking failed:', error);
    // Fallback to sending whole report if chunking fails
    return await actor_model_streaming(initialReport, setAPIError, signal);
  }
};

// CHUNKING IMPLEMENTATION (FIXED VERSION)
const chunkInitialReport = (report, maxTokens = 6000) => {
  // Split report into logical sections
  const sections = report.split(/(?=(?:^|\n)(?:#{1,3}|▪️|•|\*\*CANDIDATE|\*\*Experience|----))/m);
  
  const chunks = [];
  let currentChunk = '';
  let currentTokens = 0;
  
  for (const section of sections) {
    const sectionTokens = estimateTokens(section);
    
    if (currentTokens + sectionTokens > maxTokens && currentChunk) {
      // Save current chunk
      chunks.push({
        content: currentChunk,
        tokens: currentTokens,
        type: detectChunkType(currentChunk)
      });
      currentChunk = section;
      currentTokens = sectionTokens;
    } else {
      currentChunk += section;
      currentTokens += sectionTokens;
    }
  }
  
  // Add final chunk
  if (currentChunk) {
    chunks.push({
      content: currentChunk,
      tokens: currentTokens,
      type: detectChunkType(currentChunk)
    });
  }
  
  return chunks;
};

// Process chunks through Actor (FIXED VERSION)
const processActorAnalysis = async (initialReport, signal, actor_model_streaming, setAPIError, updateProgressFunc) => {
  const chunks = chunkInitialReport(initialReport);
  console.log(`📊 Processing ${chunks.length} chunks for Actor Analysis`);
  
  const chunkResults = [];
  let runningContext = ''; // Maintain running context
  
  for (let i = 0; i < chunks.length; i++) {
    const chunk = chunks[i];
    
    // Build context-aware prompt
    const prompt = `
      ANALYSIS CONTEXT:
      - Analyzing legal talent acquisition report (Part ${i + 1}/${chunks.length})
      - Chunk type: ${chunk.type}
      ${i > 0 ? `- Key findings so far:\n${runningContext}` : '- This is the beginning of the analysis'}
      
      CURRENT SECTION TO ANALYZE:
      ${chunk.content}
      
      INSTRUCTIONS:
      1. Analyze this section thoroughly
      2. Note any references to other candidates for later correlation
      3. ${i < chunks.length - 1 ? 'Prepare summary points for next chunk' : 'Provide final conclusions'}
      
      OUTPUT FORMAT:
      - Summary: [Brief summary of this chunk]
      - Key Findings: [Bullet points]
      - Cross-References: [References to other parts if any]
      ${i === chunks.length - 1 ? '- Final Recommendations: [Overall conclusions]' : ''}
    `;
    
    const result = await callActorModel(prompt, signal);
    chunkResults.push(result);
    
    // Update running context with key findings
    runningContext = extractKeyFindings(result).slice(-500); // Keep last 500 chars
    
    // Update UI
    updateProgress({
      stage: 'Actor Analysis',
      chunk: i + 1,
      totalChunks: chunks.length,
      currentSection: chunk.type
    });
  }
  
  return synthesizeChunkResults(chunkResults);
};

// ==================== STREAMING MODEL FUNCTIONS ====================

async function safeModelCallStreaming(
  modelFunction,
  prompt,
  setAPIError,
  signal,
  modelName = 'Model',
  maxRetries = 2,
  iterationNumber = null,
  analysisType = 'actor',
  setThinkingobj = null,
  setChatSections = null,
  patchOrAppendChatSectionsFunc = null
) {
  console.log(`[WORKFLOW] safeModelCallStreaming called:`, {
    modelName,
    iterationNumber,
    analysisType,
    promptLength: prompt.length
  });

  let lastError = null;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      console.log(`[WORKFLOW] 🔄 ${modelName} streaming attempt ${attempt}/${maxRetries}`);

      if (signal?.aborted) {
        throw new Error('Request aborted');
      }

      let accumulatedResult = '';

      const onChunk = (chunk, accumulated) => {
        accumulatedResult = accumulated;

        if (setThinkingobj && setChatSections && patchOrAppendChatSectionsFunc) {
          console.log(`[WORKFLOW] Streaming chunk for ${analysisType}, iteration ${iterationNumber}`);

          setThinkingobj((prevState) => {
            const iterations = { ...prevState.iterations };

            if (iterationNumber !== null && iterations[iterationNumber]) {
              console.log(`[WORKFLOW] Updating existing iteration ${iterationNumber} with ${analysisType}`);

              if (analysisType === 'actor') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  actorOutput: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              } else if (analysisType === 'critic') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  criticFeedback: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              } else if (analysisType === 'actorResponse') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  actorResponse: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              } else if (analysisType === 'refinedAnalysis') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  refinedAnalysis: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              } else if (analysisType === 'finalSummary') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  finalSummary: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              }
            } else if (analysisType === 'finalSummary' && iterationNumber === null) {
              return {
                ...prevState,
                finalSummary: accumulated,
                isStreamingFinalSummary: true
              };
            } else if (iterationNumber !== null) {
              console.log(`[WORKFLOW] Creating new iteration ${iterationNumber} for ${analysisType}`);

              iterations[iterationNumber] = iterations[iterationNumber] || {};

              if (analysisType === 'actor') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  actorOutput: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              } else if (analysisType === 'critic') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  criticFeedback: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              } else if (analysisType === 'actorResponse') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  actorResponse: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              } else if (analysisType === 'refinedAnalysis') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  refinedAnalysis: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              } else if (analysisType === 'finalSummary') {
                iterations[iterationNumber] = {
                  ...iterations[iterationNumber],  
                  finalSummary: accumulated,
                  isStreaming: true,
                  timestamp: new Date().toISOString()
                };
              }
            }

            const newObj = {
              ...prevState,
              iterations,
              [`isStreaming${analysisType.charAt(0).toUpperCase() + analysisType.slice(1)}`]: true
            };

            setChatSections((prev) => {
              return patchOrAppendChatSectionsFunc(prev, newObj, {
                iterations,
                [`isStreaming${analysisType.charAt(0).toUpperCase() + analysisType.slice(1)}`]: true
              });
            });

            return newObj;
          });
        }
      };

      const result = await modelFunction(prompt, setAPIError, signal, onChunk);

      if (setThinkingobj && setChatSections && patchOrAppendChatSectionsFunc) {
        console.log(`[WORKFLOW] Finalizing ${analysisType} for iteration ${iterationNumber}`);

        setThinkingobj((prevState) => {
          const iterations = { ...prevState.iterations };

          if (iterationNumber !== null) {
            iterations[iterationNumber] = iterations[iterationNumber] || {};

            console.log(`[WORKFLOW] Storing final ${analysisType} in iteration ${iterationNumber}`);

            if (analysisType === 'actor') {
              iterations[iterationNumber] = {
                ...iterations[iterationNumber],  
                actorOutput: result,
                isStreaming: false,
                completed: true,
                timestamp: new Date().toISOString()
              };
            } else if (analysisType === 'critic') {
              iterations[iterationNumber] = {
                ...iterations[iterationNumber],  
                criticFeedback: result,
                isStreaming: false,
                completed: true,
                timestamp: new Date().toISOString()
              };
            } else if (analysisType === 'actorResponse') {
              iterations[iterationNumber] = {
                ...iterations[iterationNumber],  
                actorResponse: result,
                isStreaming: false,
                completed: true,
                timestamp: new Date().toISOString()
              };
            } else if (analysisType === 'refinedAnalysis') {
              iterations[iterationNumber] = {
                ...iterations[iterationNumber],  
                refinedAnalysis: result,
                isStreaming: false,
                completed: true,
                timestamp: new Date().toISOString()
              };
            } else if (analysisType === 'finalSummary') {
              iterations[iterationNumber] = {
                ...iterations[iterationNumber],  
                finalSummary: result,
                isStreaming: false,
                completed: true,
                timestamp: new Date().toISOString()
              };
            }
          } else if (analysisType === 'finalSummary') {
            return {
              ...prevState,
              finalSummary: result,
              isStreamingFinalSummary: false
            };
          }

          const newObj = {
            ...prevState,
            iterations,
            [`isStreaming${analysisType.charAt(0).toUpperCase() + analysisType.slice(1)}`]: false
          };

          console.log(`[WORKFLOW] Final state after ${analysisType}:`, {
            iterationNumber,
            iterationContent: iterations[iterationNumber]
          });

          setChatSections((prev) => {
            return patchOrAppendChatSectionsFunc(prev, newObj, {
              iterations,
              [`isStreaming${analysisType.charAt(0).toUpperCase() + analysisType.slice(1)}`]: false
            });
          });

          return newObj;
        });
      }

      if (result && result.length > 0) {
        console.log(`[WORKFLOW] ✅ ${modelName} streaming call successful`);
        return result;
      }

      throw new Error('Empty response received');

    } catch (error) {
      lastError = error;
      console.error(`[WORKFLOW] ❌ ${modelName} streaming attempt ${attempt} failed:`, error.message);

      if (signal?.aborted || error.name === 'AbortError' || error.message.includes('aborted')) {
        throw error;
      }

      if (error.message?.includes('400') || error.message?.includes('too large')) {
        console.log('[WORKFLOW] 📏 Size issue detected, reducing prompt...');
        prompt = prompt.substring(0, Math.floor(prompt.length * 0.7)) + '\n\n[Content reduced due to size limits]';
      }

      if (attempt < maxRetries) {
        const delay = attempt * 1000;
        console.log(`[WORKFLOW] ⏳ Waiting ${delay}ms before retry...`);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }

  const errorMessage = `${modelName} failed after ${maxRetries} attempts: ${lastError?.message || 'Unknown error'}`;
  console.error(`[WORKFLOW] ❌ ${errorMessage}`);
  setAPIError(errorMessage);
  throw new Error(errorMessage);
}

const evaluateWithDeepSeekStreaming = async (
  prompt,
  setAPIError,
  signal,
  setThinkingobj,
  setChatSections,
  Actor_Model_apiProvider,
  setActor_Model_apiProvider,
  Actor_Model_apiModel,
  setActor_Model_apiModel,
  temperature_val_Actor_Model_apiProvider,
  setTemperature_val_Actor_Model_apiProvider,
  onChunk
) => {
  try {
    if (signal?.aborted) {
      throw new Error('Request aborted');
    }

    console.log('[WORKFLOW] 🚀 Calling DeepSeek with streaming');

    let result = '';

    try {
      result = await callLLMProxyStreaming('deepseek', {
        prompt,
        model: Actor_Model_apiModel || 'deepseek-reasoner',
        temperature: parseFloat(temperature_val_Actor_Model_apiProvider) || 0.3,
        max_tokens: 8192
      }, signal, onChunk);

      if (result && result.trim().length > 0) {
        console.log('[WORKFLOW] ✅ DeepSeek streaming successful');
        return result;
      }

      console.warn('[WORKFLOW] ⚠️ DeepSeek streaming returned empty response, falling back to non-streaming');

    } catch (streamError) {
      console.warn('[WORKFLOW] ⚠️ DeepSeek streaming failed:', streamError.message);
      console.log('[WORKFLOW] 🔄 Falling back to non-streaming API call');
    }

    console.log('[WORKFLOW] 📡 Using non-streaming DeepSeek API');
    const response = await callLLMProxy('deepseek', {
      prompt,
      model: Actor_Model_apiModel || 'deepseek-reasoner',
      temperature: parseFloat(temperature_val_Actor_Model_apiProvider) || 0.7,
      max_tokens: 8192
    }, signal);

    if (!response || !response.content) {
      throw new Error('Invalid response from DeepSeek (non-streaming)');
    }

    if (onChunk && response.content) {
      const chunkSize = 100;
      let accumulated = '';
      for (let i = 0; i < response.content.length; i += chunkSize) {
        const chunk = response.content.slice(i, Math.min(i + chunkSize, response.content.length));
        accumulated += chunk;
        onChunk(chunk, accumulated);
        await new Promise(resolve => setTimeout(resolve, 20));
      }
    }

    return response.content;

  } catch (error) {
    console.error('[WORKFLOW] ❌ DeepSeek error:', error);
    if (error.message.includes('aborted') || error.message.includes('cancelled')) {
      setAPIError('Request cancelled by user');
    } else {
      setAPIError(error.message || 'Failed to get response from DeepSeek');
    }
    throw error;
  }
};

const generateInsightsWithClaudeStreaming = async (
  prompt,
  setAPIError,
  signal,
  setThinkingobj,
  setChatSections,
  Actor_Model_apiProvider,
  setActor_Model_apiProvider,
  Actor_Model_apiModel,
  setActor_Model_apiModel,
  temperature_val_Actor_Model_apiProvider,
  setTemperature_val_Actor_Model_apiProvider,
  onChunk
) => {
  try {
    if (signal?.aborted) {
      throw new Error('Request aborted');
    }

    console.log('[WORKFLOW] 🚀 Calling Anthropic Claude with streaming');

    const messages = [
      {
        role: "user",
        content: prompt
      }
    ];

    let result = '';

    try {
      result = await callLLMProxyStreaming('claude', {
        messages,
        model: Actor_Model_apiModel || 'claude-3-opus-20240229',
        temperature: parseFloat(temperature_val_Actor_Model_apiProvider) || 0.3,
        max_tokens: 8192
      }, signal, onChunk);

      if (result && result.trim().length > 0) {
        console.log('[WORKFLOW] ✅ Claude streaming successful');
        return result;
      }

      console.warn('[WORKFLOW] ⚠️ Claude streaming returned empty response, falling back to non-streaming');

    } catch (streamError) {
      console.warn('[WORKFLOW] ⚠️ Claude streaming failed:', streamError.message);

      if (streamError.message.includes('Failed to fetch') ||
        streamError.message.includes('network') ||
        streamError.message.includes('Proxy')) {
        console.log('[WORKFLOW] 🔄 Claude appears to be unavailable, falling back to DeepSeek');

        return evaluateWithDeepSeekStreaming(
          prompt,
          setAPIError,
          signal,
          setThinkingobj,
          setChatSections,
          'Deepseek',
          setActor_Model_apiProvider,
          'deepseek-reasoner',
          setActor_Model_apiModel,
          temperature_val_Actor_Model_apiProvider,
          setTemperature_val_Actor_Model_apiProvider,
          onChunk
        );
      }

      console.log('[WORKFLOW] 🔄 Falling back to non-streaming Claude API');
    }

    console.log('[WORKFLOW] 📡 Using non-streaming Claude API');
    const response = await callLLMProxy('claude', {
      messages,
      model: Actor_Model_apiModel || 'claude-3-opus-20240229',
      temperature: parseFloat(temperature_val_Actor_Model_apiProvider) || 0.3,
      max_tokens: 8192
    }, signal).catch(error => {
      console.error('[WORKFLOW] Non-streaming Claude also failed:', error);

      console.log('[WORKFLOW] 🔄 Final fallback to DeepSeek');
      return callLLMProxy('deepseek', {
        prompt,
        model: 'deepseek-reasoner',
        temperature: parseFloat(temperature_val_Actor_Model_apiProvider) || 0.3,
        max_tokens: 8192
      }, signal);
    });

    if (!response || !response.content) {
      console.log('[WORKFLOW] 🔄 No response from Claude, using DeepSeek');
      const deepseekResponse = await callLLMProxy('deepseek', {
        prompt,
        model: 'deepseek-reasoner',
        temperature: parseFloat(temperature_val_Actor_Model_apiProvider) || 0.3,
        max_tokens: 8192
      }, signal);

      if (!deepseekResponse || !deepseekResponse.content) {
        throw new Error('Both Claude and DeepSeek failed to respond');
      }

      if (onChunk && deepseekResponse.content) {
        const chunkSize = 100;
        let accumulated = '';
        for (let i = 0; i < deepseekResponse.content.length; i += chunkSize) {
          const chunk = deepseekResponse.content.slice(i, Math.min(i + chunkSize, deepseekResponse.content.length));
          accumulated += chunk;
          onChunk(chunk, accumulated);
          await new Promise(resolve => setTimeout(resolve, 20));
        }
      }

      return deepseekResponse.content;
    }

    if (onChunk && response.content) {
      const chunkSize = 100;
      let accumulated = '';
      for (let i = 0; i < response.content.length; i += chunkSize) {
        const chunk = response.content.slice(i, Math.min(i + chunkSize, response.content.length));
        accumulated += chunk;
        onChunk(chunk, accumulated);
        await new Promise(resolve => setTimeout(resolve, 20));
      }
    }

    return response.content;

  } catch (error) {
    console.error('[WORKFLOW] ❌ Claude error:', error);

    if (!error.message.includes('aborted') && !error.message.includes('cancelled')) {
      console.log('[WORKFLOW] 🔄 Claude failed, attempting final fallback to DeepSeek');

      try {
        return await evaluateWithDeepSeekStreaming(
          prompt,
          setAPIError,
          signal,
          setThinkingobj,
          setChatSections,
          'Deepseek',
          setActor_Model_apiProvider,
          'deepseek-reasoner',
          setActor_Model_apiModel,
          temperature_val_Actor_Model_apiProvider,
          setTemperature_val_Actor_Model_apiProvider,
          onChunk
        );
      } catch (deepseekError) {
        console.error('[WORKFLOW] ❌ DeepSeek fallback also failed:', deepseekError);
        setAPIError('Both Claude and DeepSeek are unavailable. Please try again later.');
        throw deepseekError;
      }
    }

    if (error.message.includes('aborted') || error.message.includes('cancelled')) {
      setAPIError('Request cancelled by user');
    } else {
      setAPIError(error.message || 'Failed to get response from Claude');
    }
    throw error;
  }
};

// ==================== ACTOR-CRITIC ANALYSIS ====================

const ActorCriticAnalysis = ({
  subtopics, DeepSearch, articleshook, question, loopCount, setThinkingobj, setIter1Hook,
  setFinalSummaryhook, chatSections, setChatSections, setAPIError, signal,
  setIsLoading,
  apiError,
  Actor_Model_apiProvider, setActor_Model_apiProvider,
  Critic_Model_apiProvider, setCritic_Model_apiProvider,
  Actor_Model_apiModel, setActor_Model_apiModel,
  Critic_Model_apiModel, setCritic_Model_apiModel,
  temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
  temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider,
  profileCountChange,
  requestId,
  initialAnalysisSSE
}) => {

  const actorCriticAnalysis = async () => {
    console.log('[WORKFLOW] ===========================================');
    console.log('[WORKFLOW] === STARTING 7-STEP WORKFLOW ===');
    console.log('[WORKFLOW] ===========================================');
    console.log('[WORKFLOW] 1. Initial Report (from SSE)');
    console.log('[WORKFLOW] 2. Actor Analysis');
    console.log('[WORKFLOW] 3. First Refined Analysis');
    console.log('[WORKFLOW] 4. First Critic Feedback');
    console.log('[WORKFLOW] 5. Second Refined Analysis');
    console.log('[WORKFLOW] 6. Second Critic Feedback');
    console.log('[WORKFLOW] 7. Final Summary');
    console.log('[WORKFLOW] ===========================================');

    if (signal?.aborted) {
      setThinkingobj((prevState) => {
        const newObj = {
          ...prevState,
          error: true,
          loading: false,
          timout_err: false,
          aborted: true,
          abortedAt: new Date().toISOString()
        };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            ...prevState,
            error: true,
            loading: false,
            timout_err: false,
            aborted: true
          });
        });
        return newObj;
      });
      throw new Error('Analysis aborted');
    }
    console.log('workflow1 workflow2 stage1')
    
    let actor_model_streaming;
    let first_model = Actor_Model_apiProvider;

    if (first_model === 'Deepseek') {
      actor_model_streaming = (prompt, setAPIError, signal, onChunk) =>
        evaluateWithDeepSeekStreaming(
          prompt, setAPIError, signal, setThinkingobj, setChatSections,
          Actor_Model_apiProvider, setActor_Model_apiProvider,
          Actor_Model_apiModel, setActor_Model_apiModel,
          temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
          onChunk
        );
    } else if (first_model === 'Anthropic') {
      actor_model_streaming = (prompt, setAPIError, signal, onChunk) =>
        generateInsightsWithClaudeStreaming(
          prompt, setAPIError, signal, setThinkingobj, setChatSections,
          Actor_Model_apiProvider, setActor_Model_apiProvider,
          Actor_Model_apiModel, setActor_Model_apiModel,
          parseFloat(temperature_val_Actor_Model_apiProvider), setTemperature_val_Actor_Model_apiProvider,
          onChunk
        );
    }

    let critic_model_streaming;
    let second_model = Critic_Model_apiProvider;
    console.log('workflow1 workflow2 stage2')
    
    if (second_model === 'Deepseek') {
      critic_model_streaming = (prompt, setAPIError, signal, onChunk) =>
        evaluateWithDeepSeekStreaming(
          prompt, setAPIError, signal, setThinkingobj, setChatSections,
          Critic_Model_apiProvider, setCritic_Model_apiProvider,
          Critic_Model_apiModel, setCritic_Model_apiModel,
          temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider,
          onChunk
        );
    } else if (second_model === 'Anthropic' || second_model === 'Claude') {
      critic_model_streaming = (prompt, setAPIError, signal, onChunk) =>
        generateInsightsWithClaudeStreaming(
          prompt, setAPIError, signal, setThinkingobj, setChatSections,
          Critic_Model_apiProvider, setCritic_Model_apiProvider,
          Critic_Model_apiModel, setCritic_Model_apiModel,
          parseFloat(temperature_val_Critic_Model_apiProvider), setTemperature_val_Critic_Model_apiProvider,
          onChunk
        );
    }
    console.log('workflow1 workflow2 stage2a')
    console.log('workflow1 workflow2 stage3')
    
    try {
      setThinkingobj((prevState) => {
        const newObj = { ...prevState, actor: first_model, critic: second_model, stage: 'Starting Analysis...', loading: true, timout_err: false };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, { actor: first_model, critic: second_model, stage: 'Starting Analysis...', loading: true, timout_err: false })
        });
        return newObj;
      });

      // STEP 1: Initial Report (from SSE) - Keep all existing chunking logic
      console.log('[WORKFLOW] \n=== STEP 1: Processing Initial Report from SSE ===');
      let initialAnalysis = '';

      const INITIAL_CHUNK_THRESHOLD = 8000;
      const needsInitialChunking = initialAnalysisSSE && initialAnalysisSSE?.length > INITIAL_CHUNK_THRESHOLD;

      if (needsInitialChunking) {
        console.log('[WORKFLOW] Initial analysis needs chunking, length:', initialAnalysisSSE?.length);
        console.log('workflow1 workflow2 stage4')
        
        setThinkingobj((prevState) => {
          const newObj = {
            ...prevState,
            stage: 'Preparing chunked initial analysis...',
            loading: true,
            initialChunking: true
          };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, {
              stage: 'Preparing chunked initial analysis...',
              loading: true,
              initialChunking: true
            });
          });
          return newObj;
        });

        const modelType = 'default';
        const chunkConfig = selectChunkConfig(initialAnalysisSSE?.length, 'standard', modelType);
        const subtopicChunks = createOverlappingChunks(initialAnalysisSSE, chunkConfig);

        const chunkResults = [];

        for (let i = 0; i < subtopicChunks.length; i++) {
          const chunk = subtopicChunks[i];
          console.log('workflow1 workflow2 stage5')
          
          if (signal?.aborted) {
            throw new Error('Analysis aborted');
          }

          setThinkingobj((prevState) => {
            const newObj = {
              ...prevState,
              stage: `Processing initial chunk ${i + 1} of ${subtopicChunks.length}...`,
              initialChunkProgress: {
                current: i + 1,
                total: subtopicChunks.length,
                percentage: ((i + 1) / subtopicChunks.length * 100).toFixed(0)
              },
              loading: true
            };
            setChatSections((prev) => {
              return patchOrAppendChatSections(prev, newObj, {
                stage: `Processing initial chunk ${i + 1} of ${subtopicChunks.length}...`,
                initialChunkProgress: newObj.initialChunkProgress,
                loading: true
              });
            });
            return newObj;
          });

          const chunkMessage = `
            **CHUNK ${i + 1} of ${subtopicChunks.length}**
            ${i > 0 ? '[INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: This continues from the previous chunk with 0% overlap]' : '[This is the first chunk]'}
            ${i === subtopicChunks.length - 1 ? '[INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: This is the final chunk]' : ''}
            
            **Content:**
            ${chunk.content}
            
            **Context:**
            - INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: This is part ${i + 1} of ${subtopicChunks.length} for the query: "${question}"
            - INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: Total content length: ${subtopics.length} characters
            ${chunk.hasOverlapBefore ? '- INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: Contains overlap with previous chunk for continuity' : ''}
            ${chunk.hasOverlapAfter ? '- INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: Next chunk will overlap with this one' : ''}
            
            Please analyze this section while maintaining awareness that it's part of a larger analysis.
            Please limit your response to a few lines, focusing on the key insights and analysis of this chunk.
          `;

          try {
            let chunkAnalysis = '';

            if (Actor_Model_apiProvider === 'Deepseek') {
              chunkAnalysis = await evaluateWithDeepSeekStreaming(
                chunkMessage, setAPIError, signal, setThinkingobj, setChatSections,
                Actor_Model_apiProvider, setActor_Model_apiProvider,
                Actor_Model_apiModel, setActor_Model_apiModel,
                temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
                (chunk, accumulated) => { }
              );
            } else if (Actor_Model_apiProvider === 'Anthropic') {
              chunkAnalysis = await generateInsightsWithClaudeStreaming(
                chunkMessage, setAPIError, signal, setThinkingobj, setChatSections,
                Actor_Model_apiProvider, setActor_Model_apiProvider,
                Actor_Model_apiModel, setActor_Model_apiModel,
                temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
                (chunk, accumulated) => { }
              );
            }

            chunkResults.push(chunkAnalysis);

          } catch (error) {
            if (error?.cancelled) {
              return error;
            }
            console.error(`[WORKFLOW] ❌ Error processing chunk ${i + 1}:`, error);
            if (i === 0 || i === subtopicChunks.length - 1) {
              throw error;
            }
            chunkResults.push(`[Error: ${error.message}]`);
          }
          console.log('workflow1 workflow2 stage6')
          
          if (i < subtopicChunks.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 300));
          }
        }
        console.log('workflow1 workflow2 stage7')
        initialAnalysis = mergeChunkedAnalyses(chunkResults);

      } else {
        // Non-chunked initial analysis
        console.log('[WORKFLOW] Initial analysis does not need chunking, length:', initialAnalysisSSE?.length);

        setThinkingobj((prevState) => {
          const newObj = { ...prevState, stage: 'Generating Initial Analysis...', loading: true };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, { stage: 'Generating Initial Analysis...', loading: true });
          });
          return newObj;
        });

        if (Actor_Model_apiProvider === 'Deepseek') {
          initialAnalysis = await evaluateWithDeepSeekStreaming(
            initialAnalysisSSE, setAPIError, signal, setThinkingobj, setChatSections,
            Actor_Model_apiProvider, setActor_Model_apiProvider,
            Actor_Model_apiModel, setActor_Model_apiModel,
            temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
            (chunk, accumulated) => {
              setThinkingobj((prevState) => {
                const iterations = {
                  ...prevState.iterations,
                  [1]: {
                    ...prevState.iterations?.[1],
                    isStreaming: true,
                    timestamp: new Date().toISOString()
                  }
                };
                const newObj = {
                  ...prevState,
                  iterations,
                  isStreamingInitial: true
                };
                setChatSections((prev) => {
                  return patchOrAppendChatSections(prev, newObj, {
                    iterations,
                    isStreamingInitial: true
                  });
                });
                return newObj;
              });
            }
          );
        } else if (Actor_Model_apiProvider === 'Anthropic') {
          initialAnalysis = await generateInsightsWithClaudeStreaming(
            initialAnalysisSSE, setAPIError, signal, setThinkingobj, setChatSections,
            Actor_Model_apiProvider, setActor_Model_apiProvider,
            Actor_Model_apiModel, setActor_Model_apiModel,
            temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
            (chunk, accumulated) => {
              setThinkingobj((prevState) => {
                const iterations = {
                  ...prevState.iterations,
                  [1]: {
                    ...prevState.iterations?.[1],
                    isStreaming: true,
                    timestamp: new Date().toISOString()
                  }
                };
                const newObj = {
                  ...prevState,
                  iterations,
                  isStreamingInitial: true
                };
                setChatSections((prev) => {
                  return patchOrAppendChatSections(prev, newObj, {
                    iterations,
                    isStreamingInitial: true
                  });
                });
                return newObj;
              });
            }
          );
        }
      }
      console.log('workflow1 workflow2 stage8')
      
      console.log('[WORKFLOW] ✅ STEP 1 COMPLETE - Initial Analysis Generated');
      console.log('[WORKFLOW]    Output length:', initialAnalysis.length, 'chars');
      console.log('[WORKFLOW]    Was chunked:', needsInitialChunking);
      console.log('[WORKFLOW]    First 500 chars:', initialAnalysis.substring(0, 500));

      // Store initial analysis
      setThinkingobj((prevState) => {
        const iterations = {
          ...prevState.iterations,
          [1]: {
            ...prevState.iterations?.[1],
            isStreaming: false,
            completed: true,
            timestamp: new Date().toISOString(),
            wasChunked: needsInitialChunking
          }
        };
        const newObj = {
          ...prevState,
          iterations,
          isStreamingInitial: false,
          initialChunkProgress: null,
          stage: 'Initial Analysis Complete'
        };

        console.log('[WORKFLOW] After STEP 1, iterations state:', iterations);

        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            iterations,
            isStreamingInitial: false,
            initialChunkProgress: null,
            stage: 'Initial Analysis Complete'
          });
        });
        return newObj;
      });
      console.log('workflow1 workflow2 stage9')
      
      setIter1Hook((prevState) => ({
        ...prevState,
        iterations: {
          ...prevState.iterations,
          [1]: {
            ...prevState.iterations?.[1],
            completed: true,
            timestamp: new Date().toISOString()
          }
        },
        stage: 'Initial Analysis Complete'
      }));

      // STEP 2: Actor Analysis
      console.log('[WORKFLOW] \n=== STEP 2: Generating Actor Analysis ===');
      console.log('[WORKFLOW]    Input: Initial Analysis');
      console.log('[WORKFLOW]    Input length:', initialAnalysis.length, 'chars');
      console.log('[WORKFLOW]    First 500 chars of input:', initialAnalysis.substring(0, 500));
      console.log('workflow1 workflow2 stage10')
      
      if (signal?.aborted) {
        throw new Error('Analysis aborted before actor phase');
      }

      const ACTOR_CHUNK_THRESHOLD = 8000;
      const needsActorChunking = initialAnalysis.length > ACTOR_CHUNK_THRESHOLD;
      let actorOutput;

      if (needsActorChunking) {
        console.log('[WORKFLOW] Actor analysis needs chunking');
        console.log('workflow1 workflow2 stage11')
        
        const modelType = Actor_Model_apiProvider.toLowerCase().includes('claude') ? 'claude' :
          Actor_Model_apiProvider.toLowerCase().includes('deepseek') ? 'deepseek' :
            Actor_Model_apiProvider.toLowerCase().includes('gemini') ? 'gemini' :
              Actor_Model_apiProvider.toLowerCase().includes('anthropic') ? 'anthropic' :
                'default';

        const chunkConfig = selectChunkConfig(initialAnalysis.length, 'standard', modelType);
        const analysisChunks = createOverlappingChunks(initialAnalysis, chunkConfig);

        setThinkingobj((prevState) => {
          const newObj = {
            ...prevState,
            stage: `Preparing to analyze ${analysisChunks.length} chunks with streaming...`,
            chunkingInfo: {
              totalChunks: analysisChunks.length,
              averageChunkSize: Math.round(analysisChunks.reduce((sum, c) => sum + c.length, 0) / analysisChunks.length),
              overlapPercentage: 0,
              totalTextLength: initialAnalysis.length
            },
            loading: true
          };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, {
              stage: `Preparing to analyze ${analysisChunks.length} chunks with streaming...`,
              chunkingInfo: newObj.chunkingInfo,
              loading: true
            });
          });
          return newObj;
        });
        console.log('workflow1 workflow2 stage12')
        
        let accumulatedActorOutput = '';
        const actorChunkResults = [];
        const processingStartTime = Date.now();

        for (let i = 0; i < analysisChunks.length; i++) {
          const chunk = analysisChunks[i];
          console.log('workflow1 workflow2 stage13')
          
          if (signal?.aborted) {
            throw new Error('Analysis aborted');
          }

          setThinkingobj((prevState) => {
            const elapsedTime = Math.round((Date.now() - processingStartTime) / 1000);
            const estimatedTotalTime = analysisChunks.length > 1 ?
              Math.round((elapsedTime / (i + 1)) * analysisChunks.length) : 0;
            const remainingTime = Math.max(0, estimatedTotalTime - elapsedTime);

            const newObj = {
              ...prevState,
              stage: `Streaming chunks`,
              chunkProgress: {
                current: i + 1,
                total: analysisChunks.length,
                percentage: ((i + 1) / analysisChunks.length * 100).toFixed(0),
                currentChunkSize: chunk.length,
                elapsedTime,
                estimatedRemainingTime: remainingTime
              },
              loading: true,
              isStreamingActor: true
            };
            setChatSections((prev) => {
              return patchOrAppendChatSections(prev, newObj, {
                stage: `Streaming chunks`,
                chunkProgress: newObj.chunkProgress,
                loading: true,
                isStreamingActor: true
              });
            });
            return newObj;
          });

          const suggestedHeaders = getChunkHeaders(i, analysisChunks.length);
          console.log('workflow1 workflow2 stage14')
          
          const chunkActorPrompt = `
[INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: This is part ${i + 1} of ${analysisChunks.length} total parts]
In the report, do not mention that this is part of a multi-part analysis. Treat it as a standalone section.
${i > 0 ? `[OVERLAP INFO: ${chunk.overlapSize} characters overlap with previous section for continuity]` : ''}

**Content to Analyze:**
${chunk.content}

**Instructions:**
- INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: You are analyzing a ${analysisChunks.length}-part document about "${question}". 
- INTERNAL CONTEXT - DO NOT MENTION IN OUTPUT: This is chunk ${i + 1} of ${analysisChunks.length}.

${(() => {
              const totalChunks = analysisChunks.length;
              const currentChunk = i + 1;
              const isFirst = i === 0;
              const isLast = i === totalChunks - 1;
              const isSecondLast = i === totalChunks - 2;
              const isMiddle = !isFirst && !isLast && !isSecondLast;

              if (isFirst) {
                return `
**As the FIRST chunk, you should:**
1. Begin with an executive summary or introduction that sets the context
2. Introduce the main candidates, themes, or key elements
3. Start with headers like:
   - "Executive Summary" or "Overview"
   - "Key Candidates & Themes" 
   - "Initial Assessment"
   - "Primary Findings"
4. Establish the analytical framework for the rest of the analysis
5. DO NOT include "Final Note" or "Actionable Recommendations" yet
Please limit your response to around a few lines, focusing on the key insights and analysis of this chunk.`;
              }

              if (isMiddle) {
                return `
**As a MIDDLE chunk (${currentChunk} of ${totalChunks}), you should:**
1. Continue the analysis with detailed examination
2. Use section headers appropriate to your position like:
   - "Detailed Analysis" or "Deep Dive"
   - "Pattern Analysis" or "Emerging Themes"
   - "Sector-Specific Insights"
   - "Regulatory Landscape" 
   - "Technical Considerations"
   - "Market Context"
3. Build upon previous insights without repeating introductory material
4. Transition smoothly from where the previous section likely ended
5. DO NOT include "Final Note", "Conclusion", or final "Actionable Recommendations"
Please limit your response to around a few lines, focusing on the key insights and analysis of this chunk.`;
              }

              if (isSecondLast) {
                return `
**As the SECOND-TO-LAST chunk, you should:**
1. Begin synthesizing the analysis toward conclusions
2. Use headers like:
   - "Strategic Implications"
   - "Risk Assessment"
   - "Gap Analysis"
   - "Preliminary Recommendations"
   - "Key Considerations"
3. Start building toward final recommendations
4. Consolidate patterns and insights from earlier sections
5. You MAY include some "Actionable Recommendations" but save the final summary for the last chunk
Please limit your response to around a few lines, focusing on the key insights and analysis of this chunk.`;
              }

              if (isLast) {
                return `
**As the FINAL chunk, you should:**
1. Provide conclusive summary and recommendations
2. Use concluding headers like:
   - "Final Assessment"
   - "Actionable Recommendations"
   - "Strategic Next Steps"
   - "Implementation Roadmap"
   - "Final Note" or "Conclusion"
3. Synthesize all previous insights into clear action items
4. Provide a strong, decisive conclusion to the analysis
5. End with a "Final Note" or "Executive Summary" that captures the essence
Please limit your response to around a few lines, focusing on the key insights and analysis of this chunk.`;
              }
            })()}

**Suggested headers for this chunk position:**
${suggestedHeaders.map((h, idx) => `${idx + 1}. ${h}`).join('\n')}

**Additional Guidelines:**
- Write naturally as if this is part of a continuous, flowing analysis
- DO NOT use generic headers that could appear in any chunk
- DO NOT repeat the same header structures from other chunks
- Ensure your content and headers reflect your specific position in the document
- Maintain professional tone while varying your language to avoid repetition
- Focus on the specific aspects of "${question}" relevant to this section

Remember: The reader will see all chunks combined into one document, so each chunk should have its own unique contribution to the overall narrative.`;

          try {
            let chunkActorOutput = '';

            const onChunkReceived = (newText, chunkAccumulated) => {
              chunkActorOutput = chunkAccumulated;

              let displayedContent = '';
              if (i === 0) {
                displayedContent = accumulatedActorOutput + chunkAccumulated;
              } else {
                displayedContent = accumulatedActorOutput + '\n\n' + chunkAccumulated;
              }

              setThinkingobj((prevState) => {
                const iterations = { ...prevState.iterations };

                if (!iterations[1]) {
                  iterations[1] = {};
                }

                iterations[1].actorOutput = displayedContent;
                iterations[1].isStreaming = true;
                iterations[1].currentChunk = i + 1;
                iterations[1].totalChunks = analysisChunks.length;
                iterations[1].timestamp = new Date().toISOString();

                const newObj = {
                  ...prevState,
                  iterations,
                  isStreamingActor: true,
                  currentStreamingChunk: i + 1
                };

                setChatSections((prev) => {
                  return patchOrAppendChatSections(prev, newObj, {
                    iterations,
                    isStreamingActor: true,
                    currentStreamingChunk: i + 1
                  });
                });

                return newObj;
              });
            };

            chunkActorOutput = await actor_model_streaming(
              chunkActorPrompt,
              setAPIError,
              signal,
              onChunkReceived
            );

            if (i === 0) {
              accumulatedActorOutput = chunkActorOutput;
            } else {
              const lines = chunkActorOutput.split('\n');
              const overlapRatio = 0.3;
              const estimatedOverlapLines = Math.floor(lines.length * overlapRatio);

              let startIndex = 0;
              for (let j = Math.min(estimatedOverlapLines, lines.length - 1); j >= 0; j--) {
                const line = lines[j].trim();
                if (line === '' || line.startsWith('#') || line.startsWith('•') ||
                  line.startsWith('-') || line.match(/^\d+\./)) {
                  startIndex = j + 1;
                  break;
                }
              }

              if (startIndex === 0) {
                startIndex = estimatedOverlapLines;
              }

              const uniqueContent = lines.slice(startIndex).join('\n');

              if (accumulatedActorOutput && uniqueContent) {
                accumulatedActorOutput += '\n\n' + uniqueContent;
              } else {
                accumulatedActorOutput += uniqueContent;
              }
            }

            actorChunkResults.push({
              chunkIndex: i,
              analysis: chunkActorOutput,
              hasOverlapBefore: chunk.hasOverlapBefore,
              hasOverlapAfter: chunk.hasOverlapAfter,
              overlapSize: chunk.overlapSize,
              overlapPercentage: chunk.overlapPercentage,
              chunkLength: chunk.length
            });

            setThinkingobj((prevState) => {
              const iterations = { ...prevState.iterations };

              if (!iterations[1]) {
                iterations[1] = {};
              }

              iterations[1].actorOutput = accumulatedActorOutput;
              iterations[1].isStreaming = false;
              iterations[1].currentChunk = i + 1;
              iterations[1].totalChunks = analysisChunks.length;
              iterations[1].completedChunks = i + 1;
              iterations[1].timestamp = new Date().toISOString();

              const newObj = {
                ...prevState,
                iterations,
                isStreamingActor: i < analysisChunks.length - 1,
                currentStreamingChunk: i + 1,
                stage: `Completed chunk ${i + 1} of ${analysisChunks.length}`
              };

              setChatSections((prev) => {
                return patchOrAppendChatSections(prev, newObj, {
                  iterations,
                  isStreamingActor: i < analysisChunks.length - 1,
                  currentStreamingChunk: i + 1,
                  stage: `Completed chunk ${i + 1} of ${analysisChunks.length}`
                });
              });

              return newObj;
            });

          } catch (error) {
            console.error(`[WORKFLOW]    ❌ Error processing chunk ${i + 1}:`, error);

            if (i > 0 && i < analysisChunks.length - 1) {
              const errorMessage = `\n\n[Error processing section ${i + 1}]\n\n`;
              accumulatedActorOutput += errorMessage;

              setThinkingobj((prevState) => {
                const iterations = { ...prevState.iterations };
                if (!iterations[1]) iterations[1] = {};
                iterations[1].actorOutput = accumulatedActorOutput;

                const newObj = {
                  ...prevState,
                  iterations,
                  stage: `Error in chunk ${i + 1}, continuing...`
                };

                setChatSections((prev) => {
                  return patchOrAppendChatSections(prev, newObj, {
                    iterations,
                    stage: `Error in chunk ${i + 1}, continuing...`
                  });
                });

                return newObj;
              });

              actorChunkResults.push({
                chunkIndex: i,
                analysis: `[Error processing section ${i + 1}]`,
                hasOverlapBefore: chunk.hasOverlapBefore,
                hasOverlapAfter: chunk.hasOverlapAfter,
                error: true
              });

              continue;
            } else {
              throw error;
            }
          }

          if (i < analysisChunks.length - 1) {
            const delayMs = analysisChunks.length > 10 ? 200 : 300;
            await new Promise(resolve => setTimeout(resolve, delayMs));
          }
        }
        console.log('workflow1 workflow2 stage15')
        
        setThinkingobj((prevState) => {
          const iterations = {
            ...prevState.iterations,
            [1]: {
              ...prevState.iterations?.[1],
              actorOutput: accumulatedActorOutput,
              timestamp: new Date().toISOString(),
              wasChunked: true,
              chunkCount: analysisChunks.length,
              isStreaming: false,
              completed: true,
              chunkDetails: actorChunkResults.map((r, idx) => ({
                index: idx + 1,
                outputLength: r.analysis?.length || 0,
                error: r.error || false
              }))
            }
          };
          const newObj = {
            ...prevState,
            iterations,
            stage: `Actor Analysis Complete (${analysisChunks.length} chunks processed)`,
            loading: true,
            chunkProgress: null,
            isStreamingActor: false
          };

          console.log('[WORKFLOW] After STEP 2 (chunked), iterations state:', iterations);

          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, {
              iterations,
              stage: `Actor Analysis Complete (${analysisChunks.length} chunks processed)`,
              loading: true,
              chunkProgress: null,
              isStreamingActor: false
            });
          });
          return newObj;
        });

        actorOutput = accumulatedActorOutput;

      } else {
        // Non-chunked actor processing
        console.log('[WORKFLOW] Actor analysis does not need chunking');

        const actorPrompt = `
        **Initial Analysis:**
        ${initialAnalysis}
        
        **Original Topic:** ${question}

        As the Actor in our collaborative analysis framework, build upon this initial analysis of "${question}". 

        The initial analysis provides a foundation. Your role is to deepen and expand this analysis.

        Please provide a comprehensive analysis that enhances and refines the initial insights.
        `;

        actorOutput = await safeModelCallStreaming(
          actor_model_streaming,
          actorPrompt,
          setAPIError,
          signal,
          'Actor',
          2,
          1,
          'actor',
          setThinkingobj,
          setChatSections,
          patchOrAppendChatSections
        );

        setThinkingobj((prevState) => {
          const iterations = {
            ...prevState.iterations,
            [1]: {
              ...prevState.iterations?.[1],
              actorOutput: actorOutput,
              timestamp: new Date().toISOString(),
              isStreaming: false,
              completed: true
            }
          };
          const newObj = {
            ...prevState,
            iterations,
            stage: `Received Actor Analysis`,
            loading: true,
            isStreamingActor: false
          };

          console.log('[WORKFLOW] After STEP 2 (non-chunked), iterations state:', iterations);

          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, {
              iterations,
              stage: `Received Actor Analysis`,
              loading: true,
              isStreamingActor: false
            });
          });
          return newObj;
        });
      }
      console.log('workflow1 workflow2 stage16')
      
      console.log('[WORKFLOW] ✅ STEP 2 COMPLETE - Actor Analysis Generated');
      console.log('[WORKFLOW]    Output length:', actorOutput.length, 'chars');
      console.log('[WORKFLOW]    Was chunked:', needsActorChunking);
      console.log('[WORKFLOW]    First 500 chars of output:', actorOutput.substring(0, 500));

      setIter1Hook((prevState) => ({
        ...prevState,
        iterations: {
          ...prevState.iterations,
          [1]: {
            ...prevState.iterations?.[1],
            actorOutput: actorOutput,
            timestamp: new Date().toISOString()
          }
        },
        stage: `Received Actor Analysis`
      }));

      // STEP 3: First Refined Analysis (input: Actor Analysis)
      console.log('[WORKFLOW] \n=== STEP 3: Generating First Refined Analysis ===');
      console.log('[WORKFLOW]    Input: Actor Analysis');
      console.log('[WORKFLOW]    Input length:', actorOutput.length, 'chars');
      console.log('[WORKFLOW]    First 500 chars of input:', actorOutput.substring(0, 500));

      setThinkingobj((prevState) => {
        const newObj = {
          ...prevState,
          stage: 'Generating First Refined Analysis...',
          loading: true
        };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            stage: 'Generating First Refined Analysis...',
            loading: true
          });
        });
        return newObj;
      });

      const firstRefinedPrompt = `
        **Actor Analysis:**
        ${actorOutput}
        
        **Topic:** ${question}

        Based on the Actor's analysis above, provide a refined and enhanced analysis.
        Focus on strengthening the key insights and addressing any gaps.
      `;

      const firstRefinedAnalysis = await safeModelCallStreaming(
        actor_model_streaming,
        firstRefinedPrompt,
        setAPIError,
        signal,
        'First Refinement',
        2,
        1,
        'refinedAnalysis',
        setThinkingobj,
        setChatSections,
        patchOrAppendChatSections
      );

      setThinkingobj((prevState) => {
        const currentIteration1 = prevState.iterations?.[1] || {};
        const iterations = {
          ...prevState.iterations,
          [1]: {
            ...currentIteration1,
            refinedAnalysis: firstRefinedAnalysis,
            timestamp: new Date().toISOString()
          }
        };
        const newObj = {
          ...prevState,
          iterations,
          stage: 'First Refined Analysis Complete',
          loading: true
        };

        console.log('[WORKFLOW] After STEP 3, iterations state:', iterations);

        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            iterations,
            stage: 'First Refined Analysis Complete',
            loading: true
          });
        });
        return newObj;
      });

      console.log('[WORKFLOW] ✅ STEP 3 COMPLETE');
      console.log('[WORKFLOW]    Output length:', firstRefinedAnalysis.length, 'chars');
      console.log('[WORKFLOW]    First 500 chars of output:', firstRefinedAnalysis.substring(0, 500));

      // STEP 4: First Critic Feedback (input: First Refined Analysis)
      console.log('[WORKFLOW] \n=== STEP 4: Generating First Critic Feedback ===');
      console.log('[WORKFLOW]    Input: First Refined Analysis');
      console.log('[WORKFLOW]    Input length:', firstRefinedAnalysis.length, 'chars');
      console.log('[WORKFLOW]    First 500 chars of input:', firstRefinedAnalysis.substring(0, 500));

      setThinkingobj((prevState) => {
        const newObj = {
          ...prevState,
          stage: 'Generating First Critic Feedback...',
          loading: true
        };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            stage: 'Generating First Critic Feedback...',
            loading: true
          });
        });
        return newObj;
      });

      const firstCriticPrompt = `
        **Refined Analysis:**
        ${firstRefinedAnalysis}
        
        **Original Topic:** ${question}
        
        As the Critic, evaluate this refined analysis.
        Provide constructive feedback to further improve the analysis.
      `;

      const firstCriticFeedback = await safeModelCallStreaming(
        critic_model_streaming,
        firstCriticPrompt,
        setAPIError,
        signal,
        'First Critic',
        2,
        1,
        'critic',
        setThinkingobj,
        setChatSections,
        patchOrAppendChatSections
      );

      setThinkingobj((prevState) => {
        const currentIteration1 = prevState.iterations?.[1] || {};
        const iterations = {
          ...prevState.iterations,
          [1]: {
            ...currentIteration1,
            criticFeedback: firstCriticFeedback,
            timestamp: new Date().toISOString()
          }
        };
        const newObj = {
          ...prevState,
          iterations,
          stage: 'First Critic Feedback Complete',
          loading: true
        };

        console.log('[WORKFLOW] After STEP 4, iterations state:', iterations);

        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            iterations,
            stage: 'First Critic Feedback Complete',
            loading: true
          });
        });
        return newObj;
      });

      console.log('[WORKFLOW] ✅ STEP 4 COMPLETE');
      console.log('[WORKFLOW]    Output length:', firstCriticFeedback.length, 'chars');
      console.log('[WORKFLOW]    First 500 chars of output:', firstCriticFeedback.substring(0, 500));

      // STEP 5: Second Refined Analysis (input: First Critic Feedback)
      console.log('[WORKFLOW] \n=== STEP 5: Generating Second Refined Analysis ===');
      console.log('[WORKFLOW]    Input 1: First Refined Analysis (', firstRefinedAnalysis.length, 'chars)');
      console.log('[WORKFLOW]    Input 2: First Critic Feedback (', firstCriticFeedback.length, 'chars)');
      console.log('[WORKFLOW]    Total input length:', (firstRefinedAnalysis.length + firstCriticFeedback.length), 'chars');
      console.log('[WORKFLOW]    First 250 chars of refined analysis:', firstRefinedAnalysis.substring(0, 250));
      console.log('[WORKFLOW]    First 250 chars of critic feedback:', firstCriticFeedback.substring(0, 250));

      setThinkingobj((prevState) => {
        const newObj = {
          ...prevState,
          stage: 'Generating Second Refined Analysis...',
          loading: true
        };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            stage: 'Generating Second Refined Analysis...',
            loading: true
          });
        });
        return newObj;
      });

      const secondRefinedPrompt = `
        **Previous Refined Analysis:**
        ${firstRefinedAnalysis}
        
        **Critic's Feedback:**
        ${firstCriticFeedback}
        
        **Topic:** ${question}

        Incorporate the Critic's feedback to create an even more refined analysis.
        Address the points raised by the Critic while maintaining the strengths identified.
      `;

      const secondRefinedAnalysis = await safeModelCallStreaming(
        actor_model_streaming,
        secondRefinedPrompt,
        setAPIError,
        signal,
        'Second Refinement',
        2,
        2,
        'actor',
        setThinkingobj,
        setChatSections,
        patchOrAppendChatSections
      );

      setThinkingobj((prevState) => {
        const currentIteration2 = prevState.iterations?.[2] || {};
        const iterations = {
          ...prevState.iterations,
          [2]: {
            ...currentIteration2,
            actorOutput: secondRefinedAnalysis,
            timestamp: new Date().toISOString()
          }
        };
        const newObj = {
          ...prevState,
          iterations,
          stage: 'Second Refined Analysis Complete',
          loading: true
        };

        console.log('[WORKFLOW] After STEP 5, iterations state:', iterations);

        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            iterations,
            stage: 'Second Refined Analysis Complete',
            loading: true
          });
        });
        return newObj;
      });

      console.log('[WORKFLOW] ✅ STEP 5 COMPLETE');
      console.log('[WORKFLOW]    Output length:', secondRefinedAnalysis.length, 'chars');
      console.log('[WORKFLOW]    First 500 chars of output:', secondRefinedAnalysis.substring(0, 500));

      // STEP 6: Second Critic Feedback (input: Second Refined Analysis)
      console.log('[WORKFLOW] \n=== STEP 6: Generating Second Critic Feedback ===');
      console.log('[WORKFLOW]    Input 1: Second Refined Analysis (', secondRefinedAnalysis.length, 'chars)');
      console.log('[WORKFLOW]    Input 2: Previous Critic Feedback (', firstCriticFeedback.length, 'chars)');
      console.log('[WORKFLOW]    Total input length:', (secondRefinedAnalysis.length + firstCriticFeedback.length), 'chars');
      console.log('[WORKFLOW]    First 250 chars of second refined:', secondRefinedAnalysis.substring(0, 250));
      console.log('[WORKFLOW]    First 250 chars of first critic:', firstCriticFeedback.substring(0, 250));

      setThinkingobj((prevState) => {
        const newObj = {
          ...prevState,
          stage: 'Generating Second Critic Feedback...',
          loading: true
        };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            stage: 'Generating Second Critic Feedback...',
            loading: true
          });
        });
        return newObj;
      });

      const secondCriticPrompt = `
        **Second Refined Analysis:**
        ${secondRefinedAnalysis}
        
        **Previous Critic Feedback:**
        ${firstCriticFeedback}
        
        **Original Topic:** ${question}
        
        As the Critic, provide final feedback on this second refined analysis.
        Evaluate how well the previous feedback was incorporated and identify any remaining improvements.
      `;

      const secondCriticFeedback = await safeModelCallStreaming(
        critic_model_streaming,
        secondCriticPrompt,
        setAPIError,
        signal,
        'Second Critic',
        2,
        2,
        'critic',
        setThinkingobj,
        setChatSections,
        patchOrAppendChatSections
      );

      setThinkingobj((prevState) => {
        const currentIteration2 = prevState.iterations?.[2] || {};
        const iterations = {
          ...prevState.iterations,
          [2]: {
            ...currentIteration2,
            criticFeedback: secondCriticFeedback,
            timestamp: new Date().toISOString()
          }
        };
        const newObj = {
          ...prevState,
          iterations,
          stage: 'Second Critic Feedback Complete',
          loading: true
        };

        console.log('[WORKFLOW] After STEP 6, iterations state:', iterations);

        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            iterations,
            stage: 'Second Critic Feedback Complete',
            loading: true
          });
        });
        return newObj;
      });

      console.log('[WORKFLOW] ✅ STEP 6 COMPLETE');
      console.log('[WORKFLOW]    Output length:', secondCriticFeedback.length, 'chars');
      console.log('[WORKFLOW]    First 500 chars of output:', secondCriticFeedback.substring(0, 500));

      // STEP 7: Final Summary (input: Second Critic Feedback)
      console.log('[WORKFLOW] \n=== STEP 7: Generating Final Summary ===');
      console.log('[WORKFLOW]    Input 1: Initial Report (', initialAnalysis.length, 'chars)');
      console.log('[WORKFLOW]    Input 2: Second Refined Analysis (', secondRefinedAnalysis.length, 'chars)');
      console.log('[WORKFLOW]    Input 3: Second Critic Feedback (', secondCriticFeedback.length, 'chars)');
      console.log('[WORKFLOW]    Total input length:', (initialAnalysis.length + secondRefinedAnalysis.length + secondCriticFeedback.length), 'chars');

      setThinkingobj((prevState) => {
        const newObj = {
          ...prevState,
          stage: 'Generating Final Summary...',
          loading: true
        };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            stage: 'Generating Final Summary...',
            loading: true
          });
        });
        return newObj;
      });

      const finalSummaryPrompt = `
        **Initial Report:**
        ${initialAnalysis}
        
        **Final Refined Analysis:**
        ${secondRefinedAnalysis}
        
        **Final Critic Feedback:**
        ${secondCriticFeedback}
        
        **Topic:** ${question}
        
        Based on the entire analytical process and the final critic feedback, provide a comprehensive final summary.
        This should synthesize all insights from our iterative analysis process.
        Focus on delivering actionable insights and clear conclusions about "${question}".
      `;

      const finalSummary = await safeModelCallStreaming(
        actor_model_streaming,
        finalSummaryPrompt,
        setAPIError,
        signal,
        'Final Summary',
        2,
        2,
        'finalSummary',
        setThinkingobj,
        setChatSections,
        patchOrAppendChatSections
      );

      console.log('[WORKFLOW] ✅ STEP 7 COMPLETE - FINAL SUMMARY GENERATED');
      console.log('[WORKFLOW]    Final output length:', finalSummary.length, 'chars');
      console.log('[WORKFLOW]    First 500 chars of output:', finalSummary.substring(0, 500));

      setThinkingobj((prevState) => {
        const currentIteration2 = prevState.iterations?.[2] || {};
        const iterations = {
          ...prevState.iterations,
          [2]: {
            ...currentIteration2,
            finalSummary: finalSummary,
            timestamp: new Date().toISOString(),
            isStreaming: false,
            completed: true
          }
        };
        const newObj = {
          ...prevState,
          iterations,
          finalSummary,
          stage: 'Final Summary Complete - Analysis Completed',
          completedAt: new Date().toISOString(),
          loading: false,
          timout_err: false,
          isStreamingFinalSummary: false
        };

        console.log('[WORKFLOW] After STEP 7 (FINAL), iterations state:', iterations);

        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            iterations,
            finalSummary,
            stage: 'Final Summary Complete - Analysis Completed',
            completedAt: newObj.completedAt,
            loading: false,
            timout_err: false,
            isStreamingFinalSummary: false
          });
        });
        return newObj;
      });

      setFinalSummaryhook(finalSummary);

      console.log('[WORKFLOW] \n===========================================');
      console.log('[WORKFLOW] === 7-STEP WORKFLOW COMPLETE ===');
      console.log('[WORKFLOW] ===========================================');
      console.log('[WORKFLOW] 📊 WORKFLOW SUMMARY:');
      console.log('[WORKFLOW]    Step 1 (Initial): Input from SSE →', initialAnalysis.length, 'chars');
      console.log('[WORKFLOW]    Step 2 (Actor): Input:', initialAnalysis.length, 'chars → Output:', actorOutput.length, 'chars');
      console.log('[WORKFLOW]    Step 3 (1st Refined): Input:', actorOutput.length, 'chars → Output:', firstRefinedAnalysis.length, 'chars');
      console.log('[WORKFLOW]    Step 4 (1st Critic): Input:', firstRefinedAnalysis.length, 'chars → Output:', firstCriticFeedback.length, 'chars');
      console.log('[WORKFLOW]    Step 5 (2nd Refined): Inputs:', firstRefinedAnalysis.length, '+', firstCriticFeedback.length, '=', (firstRefinedAnalysis.length + firstCriticFeedback.length), 'chars → Output:', secondRefinedAnalysis.length, 'chars');
      console.log('[WORKFLOW]    Step 6 (2nd Critic): Inputs:', secondRefinedAnalysis.length, '+', firstCriticFeedback.length, '=', (secondRefinedAnalysis.length + firstCriticFeedback.length), 'chars → Output:', secondCriticFeedback.length, 'chars');
      console.log('[WORKFLOW]    Step 7 (Final): Inputs:', initialAnalysis.length, '+', secondRefinedAnalysis.length, '+', secondCriticFeedback.length, '=', (initialAnalysis.length + secondRefinedAnalysis.length + secondCriticFeedback.length), 'chars → Output:', finalSummary.length, 'chars');
      console.log('[WORKFLOW] ===========================================');
      console.log('[WORKFLOW] ✅ Pattern verified: Initial → Actor → Refined → Critic → Refined → Critic → Final');
      console.log('[WORKFLOW] ===========================================');

    } catch (error) {
      console.error('[WORKFLOW DEBUG] ERROR in actorCriticAnalysis:', error);

      if (error.name === 'AbortError' || error.message.includes('aborted')) {
        setThinkingobj((prevState) => {
          const newObj = {
            ...prevState,
            error: true,
            loading: false,
            aborted: true,
            abortedAt: new Date().toISOString(),
            errorMessage: 'Analysis stopped by user'
          };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, {
              error: true,
              loading: false,
              aborted: true,
              errorMessage: 'Analysis stopped by user'
            });
          });
          return newObj;
        });
      } else {
        setAPIError(error.message);
        setThinkingobj((prevState) => {
          const newObj = {
            ...prevState,
            error: true,
            loading: false,
            timout_err: false,
            errorMessage: error.message
          };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, {
              error: true,
              loading: false,
              timout_err: false,
              errorMessage: error.message
            });
          });
          return newObj;
        });
      }

      throw error;
    }
  };

  return { actorCriticAnalysis };
};

// ==================== MAIN WORKFLOW ====================
export const mainWorkflow = async (
  Searchweb, setLoadingarticles, setErrorarticles, DeepSearch, Think, input, first_img, setThinkingobj, setSubtopicshook,
  articleshook, setArticleshook, setFinalSummaryhook, setIter1Hook, chatSections, setChatSections, thinkingobj,
  signal, setIsLoading,
  apiError, setAPIError,
  Actor_Model_apiProvider, setActor_Model_apiProvider,
  Critic_Model_apiProvider, setCritic_Model_apiProvider,
  Actor_Model_apiModel, setActor_Model_apiModel,
  Critic_Model_apiModel, setCritic_Model_apiModel,
  Actor_Model_apikey, setActor_Model_apikey,
  Critic_Model_apikey, setCritic_Model_apikey,
  temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
  temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider,
  profileCountChange,
  requestId,
  setUnpaid,
  initialAnalysisSSE
) => {
  console.log('[MAIN WORKFLOW] Starting with requestId:', requestId);
  console.log('[MAIN WORKFLOW] Initial analysis SSE length:', initialAnalysisSSE?.length);

  const checkAndThrowIfAborted = (stage = 'Unknown') => {
    if (signal?.aborted) {
      console.log('[MAIN WORKFLOW] Aborted at stage:', stage);

      setThinkingobj((prevState) => {
        const newObj = {
          ...prevState,
          error: true,
          loading: false,
          stopped: true,
          stoppedAt: stage,
          stage: 'Stopped by user',
          stoppedMessage: `Analysis stopped at: ${stage}`
        };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, {
            error: true,
            loading: false,
            stopped: true,
            stoppedAt: stage,
            stage: 'Stopped by user',
            stoppedMessage: `Analysis stopped at: ${stage}`
          });
        });
        return newObj;
      });

      setIsLoading(false);

      const error = new Error('ABORT_SIGNAL');
      error.stage = stage;
      error.requestId = requestId;
      throw error;
    }
  };

  let fetchedArticles = [];

  try {
    checkAndThrowIfAborted('Workflow initialization');

    let loopCount = 0;
    try {
      loopCount = parseInt(localStorage.getItem('loops') || '0');
    } catch (error) {
      console.error('[MAIN WORKFLOW] Error getting loop count:', error);
    }

    let subtopics;
    checkAndThrowIfAborted('Before subtopics generation');
    subtopics = 'dummy';
    checkAndThrowIfAborted('After subtopics generation');

    setThinkingobj((prevState) => {
      const newObj = {
        ...prevState,
        stage: 'Ended Thinking',
        subtopics: subtopics,
        loading: true,
        timout_err: false
        };
      setChatSections((prevChats) => {
        return patchOrAppendChatSections(prevChats, newObj, {
          stage: 'Ended Thinking',
          subtopics: subtopics,
          loading: true,
          timout_err: false
        });
      });
      return newObj;
    });
    setSubtopicshook(subtopics);

    if (!subtopics) {
      console.error('[MAIN WORKFLOW] No subtopics generated, ending workflow');
      setIsLoading(false);
      return;
    }

    checkAndThrowIfAborted('Before Actor-Critic Analysis');

    console.log('[MAIN WORKFLOW] Starting Actor-Critic Analysis');

    try {
      const analysis = ActorCriticAnalysis({
        subtopics,
        articleshook: fetchedArticles,
        DeepSearch,
        loopCount,
        question: input,
        setThinkingobj,
        setIter1Hook,
        setFinalSummaryhook,
        chatSections,
        setChatSections,
        setAPIError,
        signal,
        setIsLoading,
        apiError,
        Actor_Model_apiProvider, setActor_Model_apiProvider,
        Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Actor_Model_apiModel, setActor_Model_apiModel,
        Critic_Model_apiModel, setCritic_Model_apiModel,
        Actor_Model_apikey, setActor_Model_apikey,
        Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
        temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider,
        profileCountChange,
        requestId,
        initialAnalysisSSE
      });

      checkAndThrowIfAborted('Before running Actor-Critic');
      await analysis.actorCriticAnalysis();
      checkAndThrowIfAborted('After Actor-Critic Analysis');

      console.log('[MAIN WORKFLOW] Actor-Critic Analysis completed successfully');

    } catch (error) {
      if (error.message === 'ABORT_SIGNAL') throw error;
      console.error('[MAIN WORKFLOW] Error during Actor-Critic analysis:', error);
      throw error;
    }

    checkAndThrowIfAborted('Before completion');

    setThinkingobj((prevState) => {
      const newObj = {
        ...prevState,
        stage: 'Completed',
        loading: false,
        timout_err: false,
        completedAt: new Date().toISOString()
      };
      setChatSections((prevChats) => {
        return patchOrAppendChatSections(prevChats, newObj, {
          stage: 'Completed',
          loading: false,
          timout_err: false
        });
      });
      return newObj;
    });
    setIsLoading(false);

    console.log('[MAIN WORKFLOW] Workflow completed successfully');

  } catch (error) {
    if (error.message === 'ABORT_SIGNAL') {
      console.log('[MAIN WORKFLOW] Workflow aborted by user');
      return;
    }

    console.error('[MAIN WORKFLOW] \n❌ ERROR IN MAIN WORKFLOW:');
    console.error('[MAIN WORKFLOW] Request ID:', requestId);
    console.error('[MAIN WORKFLOW] Error message:', error.message);
    if (error.message.includes('Free trial limit reached')) {
      setUnpaid(true)
    } else {
      setUnpaid(false);
    }
    console.error('[MAIN WORKFLOW] Error type:', error.name);
    console.error('[MAIN WORKFLOW] Error stack:', error.stack);

    setThinkingobj((prevState) => {
      const newObj = {
        ...prevState,
        error: true,
        loading: false,
        timout_err: error.name === 'AbortError',
        errorMessage: error.message,
        stage: 'Error'
      };
      setChatSections((prev) => {
        return patchOrAppendChatSections(prev, newObj, {
          error: true,
          loading: false,
          timout_err: error.name === 'AbortError',
          errorMessage: error.message,
          stage: 'Error'
        });
      });
      return newObj;
    });
    setAPIError(error.message);
    setIsLoading(false);
  }
};

export default mainWorkflow;